import React, { useState, useEffect, forwardRef, useMemo, useRef, useCallback } from 'react';
import {
        DataGridPremium,
    useGridApiRef,
        useGridApiContext,
        useGridSelector,
        gridPageCountSelector,
        gridPaginationModelSelector,
        gridFilteredTopLevelRowCountSelector,
    gridPaginationRowRangeSelector,
    gridRowCountSelector,
    GridPreferencePanelsValue,
    gridVisibleColumnFieldsSelector,
    gridFilteredSortedRowIdsSelector,
    getGridStringOperators
} from '@mui/x-data-grid-premium';
import {
  Button,
  Box,
  Tabs,
  Tab,
  Stack,
  IconButton,
  FormControl,
  Checkbox,
  TextField,
    InputAdornment,
    Pagination,
    Typography,
    Menu,
    MenuItem,
    Dialog, 
    DialogActions, 
    DialogContent, 
    DialogContentText, 
    DialogTitle,
    RadioGroup,
    FormControlLabel,
    Radio
} from '@mui/material';

import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import CheckBoxIcon from '@mui/icons-material/CheckBox';

import ClearIcon from '@mui/icons-material/Clear';

import CloseIcon from '@mui/icons-material/Close';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';

import { Chip } from '@mui/material';

import {
    ValidationUtility,
    CustomAutoComplete,
    TextFieldWithIconButton,
    SessionManager,
    sessionService,
    ApiManager,
    DeterminePermissions,
    LoggerUtility,
    NotificationDialog,
    RoundedSquareRefreshButton,
    WhiteRefreshIcon,
    UtilityLibrary,
    PageLoader,
    SharedService,
    ClientType
} from '../ComponentsLibrary';

import AlertNotification from '../AlertNotification';
import { set } from 'date-fns';
import { useNavigate } from 'react-router-dom';
import { useNavigationContext } from '../../functions/NavigationContext';

const QueuedGridFooter = () => {
    const apiRef = useGridApiContext();
    const pageCount = useGridSelector(apiRef, gridPageCountSelector);
    const paginationModel = useGridSelector(apiRef, gridPaginationModelSelector);
    const filteredRowCount = useGridSelector(apiRef, gridFilteredTopLevelRowCountSelector);
    const rowRange = useGridSelector(apiRef, gridPaginationRowRangeSelector);
    const totalRowCount = useGridSelector(apiRef, gridRowCountSelector);
    // const [isHovered, setIsHovered] = useState(false);
    // const [isFocused, setIsFocused] = useState(false);

    const currentPage = paginationModel?.page || 0;
    const fromIndex = filteredRowCount === 0
        ? 0
        : ((rowRange?.firstRowIndex ?? (currentPage * (paginationModel?.pageSize || 0))) + 1);
    const toIndex = filteredRowCount === 0
        ? 0
        : ((rowRange?.lastRowIndex ?? (Math.min((currentPage + 1) * (paginationModel?.pageSize || 0), filteredRowCount) - 1)) + 1);
    const showingCount = filteredRowCount === 0 ? 0 : Math.max(toIndex - fromIndex + 1, 0);

    return (
        <Box
            sx={{
                display: 'flex',
                justifyContent: 'flex-end',
                alignItems: 'center',
                px: 2,
                py: 1,
                borderTop: '1px solid #e0e0e0',
                backgroundColor: '#fff',
                minHeight: 52,
                gap: 2,
                flexWrap: 'wrap'
            }}
        >
            <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end', gap: 2, flexWrap: 'wrap', width: '100%', height: '100%' }}>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                    <Typography variant="body2" sx={{ color: '#344054', 
                        fontWeight: 500 }}>
                        Rows per page:
                    </Typography>
                    <select
                        value={paginationModel?.pageSize || 1000}
                        onChange={(event) => {
                            const nextPageSize = Number(event.target.value) || 1000;
                            apiRef.current.setPageSize(nextPageSize);
                            apiRef.current.setPage(0);
                        }}
                        //     onMouseEnter={() => setIsHovered(true)}
                        //     onMouseLeave={() => setIsHovered(false)}
                        // onFocus={() => setIsFocused(true)}
                        // onBlur={() => setIsFocused(false)}
                        style={{
                            border: '1px solid #d0d5dd',
                            borderRadius: '4px',
                            padding: '4px 8px',
                            fontSize: '12px',
                            color: '#344054',
                            ////backgroundColor: isHovered ? '#ff0000' : '#E2E6FB'
                            //backgroundColor: isFocused ? '#E2E6FB' : '#fff',
                            //backgroundColor: isFocused ? '#E2E6FB' : isHovered ? '#E2E6FB' : '#fff'
                            // backgroundColor:  '#fff',
                            // '&:hover': {
                            //     backgroundColor: '#5A73EA'
                            // }
                        }}
                        
                    >
                        {[1000, 2000, 3000, 4000, 5000].map((pageSizeOption) => (
                            <option key={pageSizeOption} value={pageSizeOption}>{pageSizeOption}</option>
                        ))}
                    </select>
                </Box>
                <Typography variant="body2" sx={{ color: '#344054', 
                    fontWeight: 500 }}>
                    {`Total Count: ${totalRowCount} | Filtered records ${fromIndex}-${toIndex} (${showingCount} showing) of ${filteredRowCount}`}
                </Typography>
                <Pagination
                    count={Math.max(pageCount, 1)}
                    page={currentPage + 1}
                    onChange={(event, value) => apiRef.current.setPage(value - 1)}
                    showFirstButton
                    showLastButton
                    color="primary"
                    size="small"
                    disabled={filteredRowCount === 0}
                    sx={{
                        '& .MuiPaginationItem-root': {
                            color: '#344054',
                            fontWeight: 500
                        },
                        '& .MuiPaginationItem-root.Mui-selected': {
                            color: '#ffffff',
                            backgroundColor: '#5A73EA',
                            fontWeight: 400,
                            '&:hover': {
                                    backgroundColor: '#5A73EA'
                                }
                        }
                    }}
                />
            </Box>
        </Box>
    );
};

const CheckboxSetFilterInput = ({ item, applyValue, apiRef }) => {
    const selectedValues = Array.isArray(item?.value)
        ? item.value.map((value) => String(value))
        : [];

    const options = useMemo(() => {
        if (!item?.field || !apiRef?.current?.getRowModels) {
            return [];
        }

        const rowModels = apiRef.current.getRowModels();
        const uniqueValues = new Set();

        rowModels.forEach((row) => {
            const rawValue = row?.[item.field];
            if (rawValue === undefined || rawValue === null || rawValue === '') {
                return;
            }

            uniqueValues.add(String(rawValue));
        });

        return Array.from(uniqueValues).sort((a, b) =>
            a.localeCompare(b, undefined, { numeric: true, sensitivity: 'base' })
        );
    }, [apiRef, item?.field]);

    const handleToggle = useCallback((value) => {
        const stringValue = String(value);
        const hasValue = selectedValues.includes(stringValue);
        const nextValues = hasValue
            ? selectedValues.filter((existing) => existing !== stringValue)
            : [...selectedValues, stringValue];

        applyValue({
            ...item,
            value: nextValues
        });
    }, [applyValue, item, selectedValues]);

    if (!item?.field) {
        return null;
    }

    return (
        <Box sx={{ minWidth: 240, maxHeight: 260, overflowY: 'auto', p: 0.5 }}>
            {options.length === 0 ? (
                <Typography variant="body2" sx={{ color: '#667085', px: 1, py: 0.5 }}>
                    No values available
                </Typography>
            ) : (
                options.map((option) => (
                    <Box
                        key={`${item.field}-${option}`}
                        sx={{ display: 'flex', alignItems: 'center', px: 0.5 }}
                    >
                        <Checkbox
                            size="small"
                            checked={selectedValues.includes(option)}
                            onChange={() => handleToggle(option)}
                        />
                        <Typography variant="body2">{option}</Typography>
                    </Box>
                ))
            )}
        </Box>
    );
};

const QueueWorkflow = forwardRef((props, ref) => {

    const errorFormName = "Queue - Workflow";

    const getTodayDate = () => new Date().toISOString().split('T')[0];

    const loginUserInfo = sessionService.getUser();
    const loginStateID = loginUserInfo ? loginUserInfo.stateID : -123456;
    const loginLegacyUserID = loginUserInfo ? loginUserInfo.legacyUserID : -123456;
    const timeZone = loginUserInfo ? loginUserInfo.timeZone : -123456;
    const masterServerDBSchema = SessionManager.GetDataFromSession("SiteSettingsDetailsKey")?.masterDBSchema;
    const userRoleID = loginUserInfo?.roleID;
    const navigate = useNavigate();
    const { setActivePage } = useNavigationContext();

    let startDate = UtilityLibrary.formatDate(new Date().toISOString(), "YYYY-MM-DD");
    let nextStepDueTS = "";
    let initialDate = "";
    let WorkflowIDListForQueue = "";
    let QueueIDListForQueue = "";
    let queueData = [];
    let queueSelectedData = [];
    let caseWorkflowIDList = ""
    let totalNumberOfRows = 0;
    let workflowData = [];

    let stateWorkflowLockoutTime = 0;

    const getSettingDetails = async() =>{
                const settingDetailIDs = [ClientType.SettingsDetail.Workflow_Parameters__Workflow_Stale_Lock_Timeout_Min];
                const params = {
                    settingsDetailIDList: settingDetailIDs,
                    yTracSiteID: loginStateID
                }
                const response = await ApiManager.GetSettingsDetailValuesFromApi(params);
                const settingValues = {}
                for (const result of response?.settingDetailsApiData ?? []){
                    settingValues[ result?.settingsDetailID] = result?.settingsDetailValue
                }
                stateWorkflowLockoutTime = settingValues[ClientType.SettingsDetail.Workflow_Parameters__Workflow_Stale_Lock_Timeout_Min] || 0;
            }
            getSettingDetails();

    const initialInfoParams = useMemo(() => ({
        UserLoginID: loginLegacyUserID,
        MasterServerDBSchema: masterServerDBSchema,
        YTracSiteID: loginStateID, // loginStateID - TO-DO - CODE_MODIFY: Modify the SiteID - Should pass StateID
        ModuleID: 1,
        WorkflowStateLockoutTime: stateWorkflowLockoutTime,
        SystemTimeZoneName: timeZone
    }), []);

    const getInitialDateFromApi = async (initialInfoParams) => {  
        try {
            let apiData = await ApiManager.GetActiveWorkflowInitialInfoList(initialInfoParams);
            nextStepDueTS = apiData[0].nextStepDueTS;
            initialDate = UtilityLibrary.formatDate(nextStepDueTS, "YYYY-MM-DD");

                updateFormFieldValues({
                    startDateTxt: initialDate 
                });
            //}

            setInitialDateValue(initialDate);
            return initialDate;
        }
        catch (error) {
            return getTodayDate(); // ← Fallback value
        }   
    };

    const [initialDateValue, setInitialDateValue] = useState(startDate);
    const initialFormData = useMemo(() => ({
        hasValidCaseData: true,
        hasValidDateData: true,
        startDateTxt: getTodayDate(), //getTodayDate(),
        endDateTxt: getTodayDate(),
        caseSearchTxt: "",
        workflowSelect: [],
        queueSelect: [],
    }), []);

    // Then use it the same way:
    const updateFormFieldValues = (updateValues) => {
        dispatchFormData({
            type: 'UPDATE_FIELDS',
            payload: updateValues
        });
    };

    const defaultCaseNumberIconsDisabled = useMemo(() => ({ search: true, copy: true, clear: true }), []);
    const initialTabFormState = useMemo(() => ({
        0: { ...initialFormData },
        1: { ...initialFormData },
        2: { ...initialFormData }
    }), [initialFormData]);
    const initialTabCaseNumberIconsState = useMemo(() => ({
        0: { ...defaultCaseNumberIconsDisabled },
        1: { ...defaultCaseNumberIconsDisabled },
        2: { ...defaultCaseNumberIconsDisabled }
    }), [defaultCaseNumberIconsDisabled]);
    const initialTabIncludeSystemActionsState = useMemo(() => ({ 0: false, 1: false, 2: false }), []);
    const initialTabGridFilterState = useMemo(() => ({
        0: { items: [] },
        1: { items: [] },
        2: { items: [] }
    }), []);
    const initialTabPaginationState = useMemo(() => ({
            0: { pageSize: 1000, page: 0 },
            1: { pageSize: 1000, page: 0 },
            2: { pageSize: 1000, page: 0 }
        }), []);
    const initialTabColumnVisibilityState = useMemo(() => ({
            0: {},
            1: {},
            2: {}
        }), []);
    const initialTabColumnWidthsState = useMemo(() => ({
            0: {},
            1: {},
            2: {}
        }), []);
    const initialTabPinnedColumnsState = useMemo(() => ({
            0: { left: [], right: [] },
            1: { left: [], right: [] },
            2: { left: [], right: [] }
        }), []);

    const [searchFormDataByTab, setSearchFormDataByTab] = useState(initialTabFormState);

    const [activeTab, setActiveTab] = useState(0);
   
    const caseSearchRefs = useRef({});
    const inputDateRefs = useRef({});
    const queueFetchSeqRef = useRef(0);
    const queueResetOnOptionsLoadRef = useRef(false);
    const [caseNumberIconsDisabledByTab, setCaseNumberIconsDisabledByTab] = useState(initialTabCaseNumberIconsState);

    const [isPageLoading, setIsPageLoading] = useState(false);

    const [notificationDialogOpen, setNotificationDialogOpen] = useState(false);
    const [notificationDialogContent, setNotificationDialogContent] = useState([]);
    const [timerNotificationDialogClose] = useState(5000);
    const [timerAutoCloseNotificationDialog] = useState(false);
    const [confirmationOpen, setConfirmationOpen] = useState(false);
    const [confirmationTitle, setConfirmationTitle] = useState('');
    const [confirmationMessage, setConfirmationMessage] = useState('');
    const [confirmationAction, setConfirmationAction] = useState(null);
    const [showCancelButton, setShowCancelButton] = useState(true); // New state for cancel button visibility
    const queuedGridApiRef = useGridApiRef();

    const initialTabResultsState = useMemo(() => ({ 0: [], 1: [], 2: [] }), []);
    const initialTabDensityState = useMemo(() => ({ 0: 'standard', 1: 'standard', 2: 'standard' }), []);
    const [resultsQueuedByTab, setResultsQueuedByTab] = useState(initialTabResultsState);
    const [allQueuedRowsByTab, setAllQueuedRowsByTab] = useState(initialTabResultsState);
    const [includeSystemActionsByTab, setIncludeSystemActionsByTab] = useState(initialTabIncludeSystemActionsState);
    const [paginationModel, setPaginationModel] = useState({ pageSize: 1000, page: 0 });
    //const [paginationModel, setPaginationModel] = useState(initialTabPaginationState);
    const [paginationModelByTab, setPaginationModelByTab] = useState(initialTabPaginationState);
    const [sortModel, setSortModel] = useState([{ field: 'actionQueued', sort: 'desc' }]);
    const [gridFilterModelByTab, setGridFilterModelByTab] = useState(initialTabGridFilterState);
    const [gridDensityByTab, setGridDensityByTab] = useState(initialTabDensityState);
    const [columnVisibilityModelByTab, setColumnVisibilityModelByTab] = useState(initialTabColumnVisibilityState);
    const [columnWidthsByTab, setColumnWidthsByTab] = useState(initialTabColumnWidthsState);
    const [pinnedColumnsByTab, setPinnedColumnsByTab] = useState(initialTabPinnedColumnsState);
    const [densityMenuAnchorEl, setDensityMenuAnchorEl] = useState(null);
    const [workflowOptions, setWorkflowOptions] = useState([]);
    const [queueOptions, setQueueOptions] = useState([]);
    const [holidayList, setHolidayList] = useState([]);
    const [clearStartdate, setClearStartdate] = useState(false); 
    //const [resultsQueue, setResultsQueue] = useState([]);
    const [exportDialogOpen, setExportDialogOpen] = useState(false);
    const [exportScope, setExportScope] = useState('all');
    const [fileName, setFileName] = useState('');
    const [includeHeaders, setIncludeHeaders] = useState(true);
    const [includeFilters, setIncludeFilters] = useState(true);
    const [format, setFormat] = useState('excel');
    const [pageSelection, setPageSelection] = useState('current');
    const [hasSearched, setHasSearched] = useState(false);
    const [refreshInterval, setRefreshInterval] = useState(15);
    const [countdown, setCountdown] = useState(0);
    const intervalRef = useRef(null);
    const [showLegalHint, setShowLegalHint] = useState(false);
    const [secondsLeft, setSecondsLeft] = useState(30);
    const [gridPanelAnchorEl, setGridPanelAnchorEl] = useState(null);
    const savedGridStateByTab = useRef({ 0: null, 1: null, 2: null });
    const columnOrderByTab = useRef({ 0: null, 1: null, 2: null });
    const hasSearchedByTab = useRef({ 0: false, 1: false, 2: false });
    const [restoreCompleted, setRestoreCompleted] = useState(false);
    const hasAutoRefreshedOnEntryRef = useRef(false);
    const shouldRefreshWorkflowAfterWalkInRef = useRef(false);
    const shouldRefreshWorkflowAfterLegalRef = useRef(false);
    const [isWorkflowOpen, setIsWorkflowOpen] = useState(false);
    const isClearingWorkflowRef = useRef(false);

    //const intervalRef = useRef(null);


    const queuedGridSx = useMemo(() => ({
        height: '100%',
        minHeight: 0,
        '& .MuiDataGrid-row:hover': {
            cursor: 'pointer'
        },
        '& .MuiDataGrid-main': {
            minHeight: 0
        },
        '& .MuiDataGrid-virtualScroller': {
            overflowX: 'auto',
            overflowY: 'auto'
        }
    }), []);

    const searchFormData = useMemo(() => searchFormDataByTab[activeTab] || initialFormData, [searchFormDataByTab, activeTab, initialFormData]);
    const caseNumberIconsDisabled = useMemo(() => caseNumberIconsDisabledByTab[activeTab] || defaultCaseNumberIconsDisabled, [caseNumberIconsDisabledByTab, activeTab, defaultCaseNumberIconsDisabled]);
    const resultsQueued = useMemo(() => resultsQueuedByTab[activeTab] || [], [resultsQueuedByTab, activeTab]);
    const allQueuedRows = useMemo(() => allQueuedRowsByTab[activeTab] || [], [allQueuedRowsByTab, activeTab]);
    const includeSystemActions = includeSystemActionsByTab[activeTab] || false;
    const gridFilterModel = useMemo(() => gridFilterModelByTab[activeTab] || { items: [] }, [gridFilterModelByTab, activeTab]);
    const gridDensity = gridDensityByTab[activeTab] || 'standard';
    const columnVisibilityModel = useMemo(() => columnVisibilityModelByTab[activeTab] || {}, [columnVisibilityModelByTab, activeTab]);
    const columnWidths = useMemo(() => columnWidthsByTab[activeTab] || {}, [columnWidthsByTab, activeTab]);
    const pinnedColumns = useMemo(() => pinnedColumnsByTab[activeTab] || { left: [], right: [] }, [pinnedColumnsByTab, activeTab]);
    const activeCaseSearchRef = caseSearchRefs.current[activeTab] || null;
    const isCaseSearchInvalid = Boolean(searchFormData.caseSearchTxt?.trim()) && !searchFormData.hasValidCaseData;

    const visibleQueuedRowCount = Math.min(resultsQueued.length, paginationModel?.pageSize || 0);
    const [selectedRows, setSelectedRows] = useState([]); // Array of selected row IDs
    const [previouslySelectedRows, setPreviouslySelectedRows] = useState([]);

    const [workflowSelectedNone, setWorkflowSelectedNone] = useState("");
    const [queueSelectedNone, setQueueSelectedNone] = useState("");

    let rowsOrFiltersRowCount = 0;
    const queuedGridContainerStyle = {
        display: 'flex',
        flexDirection: 'column',
        marginTop: '4px',
        width: '100%',
        height: '75vh',  // Viewport relative
        minHeight: '400px',
        maxHeight: 'calc(100vh - 200px)',  // Account for header/footer
        // overflow: 'hidden'
        overflow: 'auto',
        overflowX: 'auto',
        overflowY: 'auto'
    };

    const queuedEmptyStateStyle = useMemo(() => ({
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        textAlign: 'center',
        gap: '8px',
        width: '100%',
        marginTop: '4px',
        minHeight: '220px',
        border: '1px solid #e0e0e0',
        borderRadius: '4px',
        backgroundColor: '#fff'
    }), []);

    const queuePageRootStyle = {
    minHeight: '100dvh',
    width: '100%',
    paddingTop: '40px',
    display: 'flex',
    flexDirection: 'column',
    overflow: 'hidden'
    };

    const queuePageMainStyle = {
    flex: '1 1 auto',
    minHeight: 0,
    overflow: 'auto'
    };

    const siteSettings = useMemo(() => {
        const siteSettingsFromSession = SessionManager.GetDataFromSession(SessionManager.SiteSettingsDetailsKey);

        if (!siteSettingsFromSession) {
            return null;
        }

        if (typeof siteSettingsFromSession === 'string') {
            try {
                return JSON.parse(siteSettingsFromSession);
            }
            catch (error) {
                return null;
            }
        }

        return siteSettingsFromSession;
    }, []);

    const loginSiteID = loginUserInfo?.siteID || siteSettings?.siteID || siteSettings?.yTracSiteID || null;
    const masterServerDBSchema_site = siteSettings?.masterDBSchema || null;
    const caseNumberRegex = useMemo(() => (
        siteSettings?.CaseNumberRegex || { caseRegexValue: '', caseRegexMessage: '' }
    ), [siteSettings]);

    const selectedWorkflowIds = useMemo(() => {
        if (!Array.isArray(searchFormData.workflowSelect) || searchFormData.workflowSelect.length === 0) {
            return workflowOptions
                .map((option) => option.id)
                .filter((value) => value !== undefined && value !== null && value !== '');
        }

        return workflowOptions
            .filter((option) => searchFormData.workflowSelect.includes(option.value))
            .map((option) => option.id)
            .filter((value) => value !== undefined && value !== null && value !== '');
    }, [searchFormData.workflowSelect, workflowOptions]);

    useEffect(() => {
        const fetchHolidays = async () => {
            try {
                if (!loginSiteID) {
                    setHolidayList([]);
                    return;
                }

                const today = new Date();
                const holidays = await SharedService.getHolidayList(today, loginSiteID);
                setHolidayList(holidays || []);
            }
            catch (error) {
                await LoggerUtility.ManageErrorLogging(error, errorFormName, 'fetchHolidays');
                setHolidayList([]);
            }
        };

        fetchHolidays();
    }, [loginSiteID]);

    const holidayDateSet = useMemo(() => {
        return new Set(
            (holidayList || [])
                .filter((holiday) => holiday instanceof Date && !Number.isNaN(holiday.getTime()))
                .map((holiday) => `${holiday.getFullYear()}-${String(holiday.getMonth() + 1).padStart(2, '0')}-${String(holiday.getDate()).padStart(2, '0')}`)
        );
    }, [holidayList]);

    const formatDateForInput = useCallback((dateValue) => {
        if (!(dateValue instanceof Date) || Number.isNaN(dateValue.getTime())) {
            return '';
        }

        return `${dateValue.getFullYear()}-${String(dateValue.getMonth() + 1).padStart(2, '0')}-${String(dateValue.getDate()).padStart(2, '0')}`;
    }, []);

    const parseDateFromInput = useCallback((dateValue) => {
        if (!dateValue) {
            return null;
        }

        const [year, month, day] = String(dateValue).split('-').map(Number);
        if (!year || !month || !day) {
            return null;
        }

        const parsedDate = new Date(year, month - 1, day);
        if (Number.isNaN(parsedDate.getTime())) {
            return null;
        }

        parsedDate.setHours(0, 0, 0, 0);
        return parsedDate;
    }, []);

    const isBusinessDate = useCallback((dateValue) => {
        if (!dateValue) {
            return false;
        }

        const [year, month, day] = String(dateValue).split('-').map(Number);
        if (!year || !month || !day) {
            return false;
        }

        const selectedDate = new Date(year, month - 1, day);
        if (Number.isNaN(selectedDate.getTime())) {
            return false;
        }

        const dayOfWeek = selectedDate.getDay();
        if (dayOfWeek === 0 || dayOfWeek === 6) {
            return false;
        }

        const selectedKey = `${selectedDate.getFullYear()}-${String(selectedDate.getMonth() + 1).padStart(2, '0')}-${String(selectedDate.getDate()).padStart(2, '0')}`;
        return !holidayDateSet.has(selectedKey);
    }, [holidayDateSet]);

    const isStartDateSelectable = useCallback((dateValue) => {
        const normalizedDate = new Date(dateValue.getFullYear(), dateValue.getMonth(), dateValue.getDate());
        const selectedDateText = formatDateForInput(normalizedDate);

        if (!isBusinessDate(selectedDateText)) {
            return false;
        }

        const endDate = parseDateFromInput(searchFormData.endDateTxt);
        if (!endDate) {
            return true;
        }

        return normalizedDate.getTime() <= endDate.getTime();
    }, [formatDateForInput, isBusinessDate, parseDateFromInput, searchFormData.endDateTxt]);

    const isEndDateSelectable = useCallback((dateValue) => {
        const normalizedDate = new Date(dateValue.getFullYear(), dateValue.getMonth(), dateValue.getDate());
        const selectedDateText = formatDateForInput(normalizedDate);

        if (!isBusinessDate(selectedDateText)) {
            return false;
        }

        const startDate = parseDateFromInput(searchFormData.startDateTxt);
        if (!startDate) {
            return true;
        }

        return normalizedDate.getTime() >= startDate.getTime();
    }, [formatDateForInput, isBusinessDate, parseDateFromInput, searchFormData.startDateTxt]);

    const gridToolbarButtonSx = useMemo(() => ({
        display: 'flex',
        alignItems: 'center',
        fontSize: '14px',
        fontWeight: '500',
        color: '#5A73EA',
        cursor: 'pointer',
        padding: '6px 8px',
        borderRadius: '4px',
        transition: 'all 0.2s ease',
        minWidth: 'fit-content',
        '&:hover': {
            backgroundColor: 'rgba(90, 115, 234, 0.08)',
            color: '#4A63DA',
            transform: 'translateY(-1px)'
        },
        '&:active': {
            transform: 'translateY(0px)',
            backgroundColor: 'rgba(90, 115, 234, 0.12)'
        },
        '&.Mui-disabled': {
            color: '#a0abc7'
        }
    }), []);

    const setResultsQueued = useCallback((nextResults) => {
        setResultsQueuedByTab((previous) => ({
            ...previous,
            [activeTab]: typeof nextResults === 'function' ? nextResults(previous[activeTab] || []) : nextResults
        }));
    }, [activeTab, queuedGridApiRef]);

    const setAllQueuedRows = useCallback((nextRows) => {
        setAllQueuedRowsByTab((previous) => ({
            ...previous,
            [activeTab]: typeof nextRows === 'function' ? nextRows(previous[activeTab] || []) : nextRows
        }));
    }, [activeTab]);

    const dispatchFormData = useCallback((action) => {
        setSearchFormDataByTab((previous) => ({
            ...previous,
            [activeTab]: {
                ...(previous[activeTab] || initialFormData),
                ...action
            }
        }));
    }, [activeTab, initialFormData]);

    const setCaseNumberIconsDisabled = useCallback((nextValue) => {
        setCaseNumberIconsDisabledByTab((previous) => ({
            ...previous,
            [activeTab]: typeof nextValue === 'function' ? nextValue(previous[activeTab] || defaultCaseNumberIconsDisabled) : nextValue
        }));
    }, [activeTab, defaultCaseNumberIconsDisabled]);

    const setIncludeSystemActions = useCallback((nextValue) => {
        setIncludeSystemActionsByTab((previous) => ({
            ...previous,
            [activeTab]: typeof nextValue === 'function' ? nextValue(previous[activeTab] || false) : nextValue
        }));
    }, [activeTab]);

    const setGridFilterModel = useCallback((nextValue) => {
        setGridFilterModelByTab((previous) => ({
            ...previous,
            [activeTab]: typeof nextValue === 'function' ? nextValue(previous[activeTab] || { items: [] }) : nextValue
        }));
    }, [activeTab]);

    const setGridDensity = useCallback((nextValue) => {
        setGridDensityByTab((previous) => ({
            ...previous,
            [activeTab]: nextValue
        }));
    }, [activeTab]);

    const setColumnVisibilityModel = useCallback((nextValue) => {
            setColumnVisibilityModelByTab((previous) => ({
                ...previous,
                [activeTab]: typeof nextValue === 'function' ? nextValue(previous[activeTab] || {}) : nextValue
            }));
        }, [activeTab]);

    const setPinnedColumns = useCallback((nextValue) => {
            setPinnedColumnsByTab((previous) => ({
                ...previous,
                [activeTab]: typeof nextValue === 'function'
                    ? nextValue(previous[activeTab] || { left: [], right: [] })
                    : (nextValue || { left: [], right: [] })
            }));
        }, [activeTab]);

    const setColumnWidths = useCallback((nextValue) => {
            setColumnWidthsByTab((previous) => ({
                ...previous,
                [activeTab]: typeof nextValue === 'function' ? nextValue(previous[activeTab] || {}) : (nextValue || {})
            }));
        }, [activeTab]);

    const defaultPermissionsForFields = useMemo(() => ({
        clearFiltersBtn: { read: false, write: true, hide: false },
        exportDocumentsBtn: { read: false, write: true, hide: false },
        queuedWorkflowActivityDgrd: { read: false, write: true, hide: false },
        documentViewerVwr: { read: false, write: true, hide: false },
        docVwr1Editor: { read: false, write: true, hide: false },
        docVwr1ToolbarItems: { read: false, write: true, hide: false },
        docVwr2Editor: { read: false, write: true, hide: false },
        docVwr2ToolbarItems: { read: false, write: true, hide: false },
        docVwrSplitBtn: { read: false, write: true, hide: false },
        searchBtn: { read: false, write: false, hide: false },
        autoEndWorkflowBtn: { read: false, write: false, hide: false },
        btnQueueWorkflow: { read: false, write: false, hide: false },
        btnQueueLegal: { read: false, write: false, hide: false },
        btnQueueWalkIn: { read: false, write: false, hide: false },
        queueDoubleClickEvent: { read: false, write: true, hide: false },
        legalDoubleClickEvent: { read: false, write: true, hide: false },
        walkInDoubleClickEvent: { read: false, write: true, hide: false },
    }), []);
    const [formFieldAccess, setFormFieldAccess] = useState(defaultPermissionsForFields);

useEffect(() => {
     document.title = 'YTrac :: Queue';
    

}, []); 


    useEffect(() => {
        const mapWorkflowOption = (workflow, index) => {
            const workflowId = workflow?.workflowID ?? workflow?.workflowId ?? workflow?.id ?? workflow?.value ?? index + 1;
            const workflowName = workflow?.workflowName ?? workflow?.name ?? workflow?.label ?? workflow?.type ?? workflow?.value ?? '';

            if (!workflowName) {
                return null;
            }

            return {
                id: workflowId,
                type: workflowName,
                label: workflowName,
                value: workflowName
            };
        };

        const fetchWorkflowOptions = async () => {
            try {
                const workflowList = await ApiManager.GetActiveWorkflowSelectList();
                const mappedWorkflowOptions = workflowList
                    .map(mapWorkflowOption)
                    .filter(Boolean)
                    .sort((left, right) => left.label.localeCompare(right.label));
                    // Add "ALL" option at the beginning
        const workflowOptionsWithAll = [
            {
                id: 'all',           // Special ID for ALL
                type: 'All',
                label: 'All',
                value: 'All'
            },
            ...mappedWorkflowOptions  // Spread existing options
        ];

                //setWorkflowOptions(mappedWorkflowOptions);
                setWorkflowOptions(workflowOptionsWithAll);
            }
            catch (error) {
                await LoggerUtility.ManageErrorLogging(error, errorFormName, 'fetchWorkflowOptions');
                setWorkflowOptions([]);
            }
        };

        fetchWorkflowOptions();
    }, []);

    useEffect(() => {
    if (workflowOptions && workflowOptions.length > 0) {
        // Get all workflow values except "ALL" 
        const allWorkflowValues = workflowOptions
            .filter(option => option.value !== 'All')
            .map(option => option.value);
        
        // Only set if not already initialized to avoid overriding user selections
        if (searchFormData.workflowSelect.length === 0) {
            dispatchFormData({
                workflowSelect: allWorkflowValues
            });
        }
    }
}, [workflowOptions]); // Runs when workflowOptions chang

    useEffect(() => {
        const mapQueueOption = (queue, index) => {
            //const queueId = queue?.departmentID ?? queue?.departmentId ?? queue?.queueID ?? queue?.queueId ?? queue?.id ?? queue?.value ?? index + 1;
            const departmentID = queue?.departmentID ?? queue?.departmentId ?? queue?.queueID ?? queue?.queueId ?? queue?.id ?? index + 1;
            const queueName = queue?.departmentName ?? queue?.queueName ?? queue?.name ?? queue?.label ?? queue?.type ?? queue?.value ?? '';

            //if (!queueName) {
            if (!queueName || !departmentID) {
                return null;
            }

            return {
                //id: queueId,
                id: departmentID,
                departmentID: departmentID,  // Explicit department ID
                queueName: queueName,        // Explicit queue name  
                type: queueName,
                label: queueName,
                //value: queueName
                value: departmentID  // Use departmentID as the value for selection
            };
        };

        // const queueFetchSeqRef = useRef(0);
        const requestId = ++queueFetchSeqRef.current;

        const fetchQueueOptions = async () => {
            // const requestId = ++queueFetchSeqRef.current;
            if (!loginSiteID || !masterServerDBSchema_site || selectedWorkflowIds.length === 0) {
                setQueueOptions([]);
                return;
            }

            try {
                 const results = await Promise.allSettled(
                    selectedWorkflowIds.map((workflowId) => ApiManager.GetActiveQueueList({
                        WorkflowIDList: workflowId,
                        YTracSiteID: loginSiteID,
                        MasterServerDBSchema: masterServerDBSchema_site
                    }))
                );

                if (requestId !== queueFetchSeqRef.current) return;

                const successfulLists = results
                    .filter(r => r.status === "fulfilled")
                    .map(r => r.value)
                    .flat();

                const uniqueQueuesByKey = new Map();
                successfulLists
                    .forEach((queue, index) => {        
                        const mappedQueue = mapQueueOption(queue, index);

                        if (!mappedQueue) {
                            return;
                        }

                        const dedupeKey = `${mappedQueue.id}::${mappedQueue.value}`;
                        uniqueQueuesByKey.set(dedupeKey, mappedQueue);
                    });

                const mappedQueueOptions = Array.from(uniqueQueuesByKey.values())
                    .sort((left, right) => left.label.localeCompare(right.label));

                // setQueueOptions(mappedQueueOptions);

                // Add "ALL" option at the beginning
                const queueOptionsWithAll = [
                    {
                        id: 'all-queue',           // Special ID for ALL
                        departmentID: 'all-queue',
                        queueName: 'All',
                        type: 'All',
                        label: 'All',
                        value: 'All'              // Use 'All' as the value
                    },
                    ...mappedQueueOptions         // Spread existing options
                ];

                setQueueOptions(queueOptionsWithAll);
            }
            catch (error) {
                await LoggerUtility.ManageErrorLogging(error, errorFormName, 'fetchQueueOptions');
                setQueueOptions([]);
            }
        };

        fetchQueueOptions();
    }, [loginSiteID, masterServerDBSchema_site, selectedWorkflowIds]);

    useEffect(() => {
        if (!queueOptions || queueOptions.length === 0) {
            return;
        }

        const allQueueValues = queueOptions
            .filter((option) => option.value !== 'All')
            .map((option) => option.value);

        if (queueResetOnOptionsLoadRef.current) {
            queueResetOnOptionsLoadRef.current = false;
            dispatchFormData({ queueSelect: allQueueValues });
            return;
        }

        // Only set if not already initialized to avoid overriding user selections
        if (searchFormData.queueSelect.length === 0) {
            dispatchFormData({ queueSelect: allQueueValues });
        }
    }, [queueOptions]); // Runs when queueOptions changes

    useEffect(() => {
        if (!Array.isArray(searchFormData.queueSelect) || searchFormData.queueSelect.length === 0) {
            return;
        }

        const availableQueueValues = new Set(queueOptions.map((option) => option.value));
        const nextQueueSelection = searchFormData.queueSelect.filter((queueValue) => availableQueueValues.has(queueValue));

        if (nextQueueSelection.length !== searchFormData.queueSelect.length) {
            dispatchFormData({ queueSelect: nextQueueSelection });
        }
    }, [queueOptions, searchFormData.queueSelect, dispatchFormData]);

    useEffect(() => {
        const fetchFormFieldPermissions = async () => {
            try {
                const loginUserInfo = sessionService.getUser();
                const loginStateID = loginUserInfo ? loginUserInfo.stateID : -123456;

                const params = {
                    clientID: loginStateID,
                    formID: 200 // TODO: replace with Queued page FormID
                };

                const controlSecurityListApiData = await ApiManager.FetchControlsPermissions(params);
                const actualPermissionsForFields = DeterminePermissions(controlSecurityListApiData);

                setFormFieldAccess({ ...defaultPermissionsForFields, ...actualPermissionsForFields });
            } catch (error) {
                throw LoggerUtility.ProcessErrorData(error, "fetchFormFieldPermissions", {});
            }
        };

        fetchFormFieldPermissions();
    }, [defaultPermissionsForFields]);
  

    const handleRowSelection = (rowId, isSelected) => {
            // console.log('handleRowSelection called:', { rowId, isSelected, currentSelectedRows: selectedRows });
        
        if (isSelected) {
            setSelectedRows(prev => {
                if (prev.includes(rowId)) return prev; // Avoid duplicates
                const newRows = [...prev, rowId];
                // console.log('Adding row:', rowId, 'New selected:', newRows);
                return newRows;
            });
            } 
        else {
                setSelectedRows(prev => {
                    const newRows = prev.filter(id => id !== rowId);
                    // console.log('Removing row:', rowId, 'New selected:', newRows);
                    return newRows;
                });
            }
    };


    // Select/deselect all rows
    const handleSelectAll = (event) => {
        if (event.target.checked) {
            const allRowIds = resultsQueued.map(row => row.id);
            setSelectedRows(allRowIds);
        } 
        else {
             setSelectedRows([]);
        }
     };

    // All possible grid columns for different views
    const allGridColumns = useMemo(() => ({
        caseNumber: { field: 'caseNumber', headerName: 'Case', width: 150, minWidth: 120, sortable: true, filterable: true, hideable: true, pinnable: true, pinned: 'left' },
        ytracCaseID: { field: 'ytracCaseID', headerName: 'Y-Trac Contact ID', width: 120, minWidth: 100, sortable: true, filterable: true, hideable: true },
        contactID: { field: 'contactID', headerName: 'Y-Trac Contact ID', width: 120, minWidth: 100, sortable: true, filterable: true, hideable: true },
        lastAction: { field: 'lastAction', headerName: 'Last Action', width: 150, minWidth: 120, sortable: true, filterable: true, hideable: true },
        lastActionDate: { field: 'lastActionDate', headerName: 'Last Action Date', type: 'date', 
            valueGetter: (value, row) => {
                const raw = row?.lastActionDate;
                if (!raw) return null;
                const dt = new Date(raw);
                return Number.isNaN(dt.getTime()) ? null : dt;
            },
            valueFormatter: (value) => {
                if (!value) return '';
                const d = value instanceof Date ? value : new Date(value);
                const mm = String(d.getMonth() + 1).padStart(2, '0');
                const dd = String(d.getDate()).padStart(2, '0');
                const yyyy = d.getFullYear();
                const formatted = mm + '/' + dd + '/' + yyyy;
                return formatted;
            }, 
            width: 140, minWidth: 120, sortable: true, filterable: true, hideable: true,
            sortComparator: (v1, v2) => {
                const t1 = v1 ? new Date(v1).getTime() : -Infinity;
                const t2 = v2 ? new Date(v2).getTime() : -Infinity;
                return t1 - t2;
            }},   
        //lastActionDate: { field: 'lastActionDate', headerName: 'Last Action Date', width: 140, minWidth: 120, sortable: true, filterable: true, hideable: true, type: 'string'},   
        lastActionUser: { field: 'lastActionUser', headerName: 'Last Action By', width: 140, minWidth: 120, sortable: true, filterable: true, hideable: true },
        lockUserLoginName: { field: 'lockUserLoginName', headerName: 'Locked By', width: 150, minWidth: 130, sortable: true, filterable: true, hideable: true },
        lockedLocation: { field: 'lockedLocation', headerName: 'Locked Location', width: 140, minWidth: 120, sortable: true, filterable: true, hideable: true },
        caseWorkflowID: { field: 'caseWorkflowID', headerName: 'Workflow Number', width: 140, minWidth: 120, sortable: true, filterable: true, hideable: true },
        //workflowID: { field: 'workflowID', headerName: 'WorkflowID', width: 100, minWidth: 80, sortable: true, filterable: true, hideable: true },
        workflowName: { field: 'workflowName', headerName: 'Workflow', width: 180, minWidth: 150, sortable: true, filterable: true, hideable: true },
        departmentName: { field: 'departmentName', headerName: 'Queue', width: 160, minWidth: 140, sortable: true, filterable: true, hideable: true },
        workflowStepName: { field: 'workflowStepName', headerName: 'Next Action Type', width: 180, minWidth: 150, sortable: true, filterable: true, hideable: true },
        standardWorkTimeEst: { field: 'standardWorkTimeEst', headerName: 'STD Time Est (NAT)', width: 160, minWidth: 140, sortable: true, filterable: true, hideable: true, type: 'number',
            renderCell: (params) => {
                    const totalSeconds = params.value || 0;
                    const days = Math.floor(totalSeconds / 86400);
                    const hours = Math.floor((totalSeconds % 86400) / 3600);
                    const minutes = Math.floor((totalSeconds % 3600) / 60);
                    const seconds = totalSeconds % 60;
                    const mm = String(minutes).padStart(2, '0');
                    const ss = String(seconds).padStart(2, '0');
                    const hh = String(hours).padStart(2, '0');

                    
                    if (days > 0) {
                return `${days}:${hh}:${mm}:${ss}`;
            }
            if (hours > 0) {
                return `${hh}:${mm}:${ss}`;
            }
            return `${mm}:${ss}`;
        }
         },
        stepPriority: { field: 'stepPriority', headerName: 'Priority', width: 90, minWidth: 70, sortable: true, filterable: true, hideable: true, type: 'number', align: 'center', headerAlign: 'left' },
        nextStepDueTS: {  field: 'nextStepDueTS', headerName: 'Next Action Due Date', type: 'date', 
            valueGetter: (value, row) => {
                const raw = row?.nextStepDueTS;
                if (!raw) return null;
                const dt = new Date(raw);
                return Number.isNaN(dt.getTime()) ? null : dt;
            },
            valueFormatter: (value) => {
                if (!value) return '';
                const d = value instanceof Date ? value : new Date(value);
                const mm = String(d.getMonth() + 1).padStart(2, '0');
                const dd = String(d.getDate()).padStart(2, '0');
                const yyyy = d.getFullYear();
                const formatted = mm + '/' + dd + '/' + yyyy;
                return formatted;
            }, 
            width: 140, minWidth: 120, sortable: true, filterable: true, hideable: true,
            sortComparator: (v1, v2) => {
                const t1 = v1 ? new Date(v1).getTime() : -Infinity;
                const t2 = v2 ? new Date(v2).getTime() : -Infinity;
                return t1 - t2;
            }},  
            
        nextStepDueDateOnly: { field: 'nextStepDueDateOnly', headerName: 'Date Entered Queue', type: 'string',
        valueGetter: (value, row) => {
                const raw = row?.nextStepDueDateOnly;
                if (!raw) return null;
                const dt = new Date(raw);
                return Number.isNaN(dt.getTime()) ? null : dt;
            },
            valueFormatter: (value) => {
                if (!value) return '';
                const d = value instanceof Date ? value : new Date(value);
                const mm = String(d.getMonth() + 1).padStart(2, '0');
                const dd = String(d.getDate()).padStart(2, '0');
                const yyyy = d.getFullYear();
                const formatted = mm + '/' + dd + '/' + yyyy;
                return formatted;
            }, 
            width: 140, minWidth: 120, sortable: true, filterable: true, hideable: true,
            sortComparator: (v1, v2) => {
                const t1 = v1 ? new Date(v1).getTime() : -Infinity;
                const t2 = v2 ? new Date(v2).getTime() : -Infinity;
                return t1 - t2;
            }},  
        daysPastDue: { field: 'daysPastDue', headerName: 'Days in Queue', width: 120, minWidth: 100, sortable: true, filterable: true, hideable: true, type: 'number' },
        waitTimeSeconds: { field: 'waitTimeSeconds', headerName: 'Wait Time', width: 130, minWidth: 110, sortable: true, filterable: true, hideable: true, type: 'number', align: 'left', headerAlign: 'left',
                    renderCell: (params) => {
                    const totalSeconds = params.value || 0;
                    const days = Math.floor(totalSeconds / 86400);
                    const hours = Math.floor((totalSeconds % 86400) / 3600);
                    const minutes = Math.floor((totalSeconds % 3600) / 60);
                    const seconds = totalSeconds % 60;
                    const mm = String(minutes).padStart(2, '0');
                    const ss = String(seconds).padStart(2, '0');
                    const hh = String(hours).padStart(2, '0');

                    
                    if (days > 0) {
                return `${days}:${hh}:${mm}:${ss}`;
            }
            if (hours > 0) {
                return `${hh}:${mm}:${ss}`;
            }
            return `${mm}:${ss}`;
            }
          },
        timeAllowedInQueue: { field: 'timeAllowedInQueue', headerName: 'Time Allowed in Queue', width: 160, minWidth: 140, sortable: true, filterable: true, hideable: true, type: 'number' },
        timeRemaining: { field: 'timeRemaining', headerName: 'Time Remaining', width: 130, minWidth: 110, sortable: true, filterable: true, hideable: true, type: 'number' },
        workedOnTime: { field: 'workedOnTime', headerName: 'Worked on Time (Y/N)', width: 130, minWidth: 110, sortable: true, filterable: true, hideable: true, type: 'number' },
        autoEndWF: { 
            field: 'autoEndWF', 
            headerName: 'Refer to Auto-End Workflow', 
            width: 250, 
            minWidth: 90, 
            sortable: true, 
            filterable: true, 
            hideable: false,
            
            align: 'center',        // Centers cell content
            headerAlign: 'left',    // Keeps header left-aligned
            renderHeader: () => (
                <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                    <Checkbox
                        checked={selectedRows.length === resultsQueued.length && resultsQueued.length > 0}
                        indeterminate={selectedRows.length > 0 && selectedRows.length < resultsQueued.length}
                        onChange={handleSelectAll}
                        size="small"
                        color="primary"
                    />
                    {/* <span>Refer to Auto-End Workflow</span> */}
                    <span style={{
                        fontFamily: '"Roboto","Helvetica","Arial",sans-serif',
                        fontSize: '0.875rem',
                        fontWeight: 500,
                        lineHeight: '1.5rem',
                        color: 'rgba(0, 0, 0, 0.87)'
                    }}>
                        Refer to Auto-End Workflow
                    </span>
                </div>
            ),
            renderCell: (params) => (
                <Checkbox
                    checked={selectedRows.includes(params.row.id)}
                    onChange={(event) => {
                        // console.log('🖱️ Checkbox onChange fired!');
                        handleRowSelection(params.row.id, event.target.checked);
                        // console.log('🖱️ After calling handleRowSelection');
                    }}
                    size="small"
                    color="primary"
                />
            ),
            sortComparator: (v1, v2) => Number(v2) - Number(v1)  // Checked (1) sorts first
        },
        contactRole: { field: 'contactRole', headerName: 'Role', width: 130, minWidth: 110, sortable: true, filterable: true, hideable: true },
        contactFirstName: { field: 'contactFirstName', headerName: 'First Name', width: 130, minWidth: 110, sortable: true, filterable: true, hideable: true },
        contactLastName: { field: 'contactLastName', headerName: 'Last Name', width: 130, minWidth: 110, sortable: true, filterable: true, hideable: true },
        caseTypeName: { field: 'caseTypeName', headerName: 'Case Type', width: 130, minWidth: 110, sortable: true, filterable: true, hideable: true },
        jurisdiction: { field: 'jurisdiction', headerName: 'District', width: 120, minWidth: 100, sortable: true, filterable: true, hideable: true },
        currentAttorney: { field: 'currentAttorney', headerName: 'Current Attorney', flex: 2, minWidth: 140, resizable: true, hideable: true },
        currentLegalSpecialist: { field: 'currentLegalSpecialist', headerName: 'Current Legal Specialist', flex: 2.8, minWidth: 190, resizable: true, hideable: true },
        NCPName: { field: 'NCPName', headerName: 'NCP Name', flex: 2.8, minWidth: 190, resizable: true, hideable: true },
        legalActionType: { field: 'legalActionType', headerName: 'Legal Action Type', flex: 2.2, minWidth: 160, resizable: true, hideable: true },
        legalStatusReview: { field: 'legalStatusReview', headerName: 'Legal Status Review', flex: 2.3, minWidth: 170, resizable: true, hideable: true },
        reviewResult: { field: 'reviewResult', headerName: 'Review Result', flex: 1.5, minWidth: 130, resizable: true, hideable: true },
        reviewNotes: { field: 'reviewNotes', headerName: 'Review Notes', flex: 1.5, minWidth: 130, resizable: true, hideable: true },
        legalWorkflowOpened: { field: 'legalWorkflowOpened', headerName: 'Legal Workflow Opened', flex: 2.8, minWidth: 190, resizable: true, hideable: true, type: 'date', 
            valueGetter: (value, row) => {
                const raw = row?.legalWorkflowOpened;
                if (!raw) return null;
                const dt = new Date(raw);
                return Number.isNaN(dt.getTime()) ? null : dt;
            },
            valueFormatter: (value) => {
                if (!value) return '';
                const d = value instanceof Date ? value : new Date(value);
                const mm = String(d.getMonth() + 1).padStart(2, '0');
                const dd = String(d.getDate()).padStart(2, '0');
                const yyyy = d.getFullYear();
                const formatted = mm + '/' + dd + '/' + yyyy;
                return formatted;
            }, 
            sortable: true, filterable: true,
            sortComparator: (v1, v2) => {
                const t1 = v1 ? new Date(v1).getTime() : -Infinity;
                const t2 = v2 ? new Date(v2).getTime() : -Infinity;
                return t1 - t2;
            }},
        legalRefApprovedRejected: { field: 'legalRefApprovedRejected', headerName: 'Legal Ref Approved/Rejected', flex: 3.2, minWidth: 220, resizable: true, hideable: true, type: 'date', 
            valueGetter: (value, row) => {
                const raw = row?.legalRefApprovedRejected;
                if (!raw) return null;
                const dt = new Date(raw);
                return Number.isNaN(dt.getTime()) ? null : dt;
            },
            valueFormatter: (value) => {
                if (!value) return '';
                const d = value instanceof Date ? value : new Date(value);
                const mm = String(d.getMonth() + 1).padStart(2, '0');
                const dd = String(d.getDate()).padStart(2, '0');
                const yyyy = d.getFullYear();
                const formatted = mm + '/' + dd + '/' + yyyy;
                return formatted;
            }, 
            sortable: true, filterable: true,
            sortComparator: (v1, v2) => {
                const t1 = v1 ? new Date(v1).getTime() : -Infinity;
                const t2 = v2 ? new Date(v2).getTime() : -Infinity;
                return t1 - t2;
            }},   
        pleadingsPrepSentToAtty: { field: 'pleadingsPrepSentToAtty', headerName: 'Pleadings Prep/Sent to Atty', flex: 3.2, minWidth: 220, resizable: true, hideable: true, type: 'date', 
            valueGetter: (value, row) => {
                const raw = row?.pleadingsPrepSentToAtty;
                if (!raw) return null;
                const dt = new Date(raw);
                return Number.isNaN(dt.getTime()) ? null : dt;
            },
            valueFormatter: (value) => {
                if (!value) return '';
                const d = value instanceof Date ? value : new Date(value);
                const mm = String(d.getMonth() + 1).padStart(2, '0');
                const dd = String(d.getDate()).padStart(2, '0');
                const yyyy = d.getFullYear();
                const formatted = mm + '/' + dd + '/' + yyyy;
                return formatted;
            }, 
           sortable: true, filterable: true,
            sortComparator: (v1, v2) => {
                const t1 = v1 ? new Date(v1).getTime() : -Infinity;
                const t2 = v2 ? new Date(v2).getTime() : -Infinity;
                return t1 - t2;
            }},   
        pleadingsApprSignedByAtty: { field: 'pleadingsApprSignedByAtty', headerName: 'Pleadings Appr/Signed by Atty', flex: 3.5, minWidth: 240, resizable: true, hideable: true,type: 'date', 
            valueGetter: (value, row) => {
                const raw = row?.pleadingsApprSignedByAtty;
                if (!raw) return null;
                const dt = new Date(raw);
                return Number.isNaN(dt.getTime()) ? null : dt;
            },
            valueFormatter: (value) => {
                if (!value) return '';
                const d = value instanceof Date ? value : new Date(value);
                const mm = String(d.getMonth() + 1).padStart(2, '0');
                const dd = String(d.getDate()).padStart(2, '0');
                const yyyy = d.getFullYear();
                const formatted = mm + '/' + dd + '/' + yyyy;
                return formatted;
            }, 
            sortable: true, filterable: true,
            sortComparator: (v1, v2) => {
                const t1 = v1 ? new Date(v1).getTime() : -Infinity;
                const t2 = v2 ? new Date(v2).getTime() : -Infinity;
                return t1 - t2;
            }},   
        deliveredToClerkForFiling: { field: 'deliveredToClerkForFiling', headerName: 'Delivered to Clerk for Filing', flex: 3.2, minWidth: 220, resizable: true, hideable: true, type: 'date', 
            valueGetter: (value, row) => {
                const raw = row?.deliveredToClerkForFiling;
                if (!raw) return null;
                const dt = new Date(raw);
                return Number.isNaN(dt.getTime()) ? null : dt;
            },
            valueFormatter: (value) => {
                if (!value) return '';
                const d = value instanceof Date ? value : new Date(value);
                const mm = String(d.getMonth() + 1).padStart(2, '0');
                const dd = String(d.getDate()).padStart(2, '0');
                const yyyy = d.getFullYear();
                const formatted = mm + '/' + dd + '/' + yyyy;
                return formatted;
            }, 
            sortable: true, filterable: true,
            sortComparator: (v1, v2) => {
                const t1 = v1 ? new Date(v1).getTime() : -Infinity;
                const t2 = v2 ? new Date(v2).getTime() : -Infinity;
                return t1 - t2;
            }},   
        dateFiledWithClerk: { field: 'dateFiledWithClerk', headerName: 'Date Filed with Clerk', flex: 2.5, minWidth: 170, resizable: true, hideable: true, type: 'date', 
            valueGetter: (value, row) => {
                const raw = row?.dateFiledWithClerk;
                if (!raw) return null;
                const dt = new Date(raw);
                return Number.isNaN(dt.getTime()) ? null : dt;
            },
            valueFormatter: (value) => {
                if (!value) return '';
                const d = value instanceof Date ? value : new Date(value);
                const mm = String(d.getMonth() + 1).padStart(2, '0');
                const dd = String(d.getDate()).padStart(2, '0');
                const yyyy = d.getFullYear();
                const formatted = mm + '/' + dd + '/' + yyyy;
                return formatted;
            }, 
            sortable: true, filterable: true,
            sortComparator: (v1, v2) => {
                const t1 = v1 ? new Date(v1).getTime() : -Infinity;
                const t2 = v2 ? new Date(v2).getTime() : -Infinity;
                return t1 - t2;
            }},   
        dlvdForServiceOfProcess: { field: 'dlvdForServiceOfProcess', headerName: 'Dlvd for Service of Process', flex: 3, minWidth: 200, resizable: true, hideable: true, type: 'date', 
            valueGetter: (value, row) => {
                const raw = row?.dlvdForServiceOfProcess;
                if (!raw) return null;
                const dt = new Date(raw);
                return Number.isNaN(dt.getTime()) ? null : dt;
            },
            valueFormatter: (value) => {
                if (!value) return '';
                const d = value instanceof Date ? value : new Date(value);
                const mm = String(d.getMonth() + 1).padStart(2, '0');
                const dd = String(d.getDate()).padStart(2, '0');
                const yyyy = d.getFullYear();
                const formatted = mm + '/' + dd + '/' + yyyy;
                return formatted;
            }, 
            sortable: true, filterable: true,
            sortComparator: (v1, v2) => {
                const t1 = v1 ? new Date(v1).getTime() : -Infinity;
                const t2 = v2 ? new Date(v2).getTime() : -Infinity;
                return t1 - t2;
            }},   
        serviceType: { field: 'serviceType', headerName: 'Service Type', flex: 1.5, minWidth: 130, resizable: true, hideable: true },
        dateOfServiceFailure: { field: 'dateOfServiceFailure', headerName: 'Date of Service/Failure', flex: 2.7, minWidth: 180, resizable: true, hideable: true, type: 'date', 
            valueGetter: (value, row) => {
                const raw = row?.dateOfServiceFailure;
                if (!raw) return null;
                const dt = new Date(raw);
                return Number.isNaN(dt.getTime()) ? null : dt;
            },
            valueFormatter: (value) => {
                if (!value) return '';
                const d = value instanceof Date ? value : new Date(value);
                const mm = String(d.getMonth() + 1).padStart(2, '0');
                const dd = String(d.getDate()).padStart(2, '0');
                const yyyy = d.getFullYear();
                const formatted = mm + '/' + dd + '/' + yyyy;
                return formatted;
            }, 
            sortable: true, filterable: true,
            sortComparator: (v1, v2) => {
                const t1 = v1 ? new Date(v1).getTime() : -Infinity;
                const t2 = v2 ? new Date(v2).getTime() : -Infinity;
                return t1 - t2;
            }},   
        serviceResults: { field: 'serviceResults', headerName: 'Service Results', flex: 1.8, minWidth: 140, resizable: true, hideable: true },
        hearingType: { field: 'hearingType', headerName: 'Hearing Type', flex: 1.5, minWidth: 130, resizable: true, hideable: true },
        hearingDate: { field: 'hearingDate', headerName: 'Hearing Date', flex: 1.5, minWidth: 130, resizable: true, hideable: true, type: 'date', 
            valueGetter: (value, row) => {
                const raw = row?.hearingDate;
                if (!raw) return null;
                const dt = new Date(raw);
                return Number.isNaN(dt.getTime()) ? null : dt;
            },
            valueFormatter: (value) => {
                if (!value) return '';
                const d = value instanceof Date ? value : new Date(value);
                const mm = String(d.getMonth() + 1).padStart(2, '0');
                const dd = String(d.getDate()).padStart(2, '0');
                const yyyy = d.getFullYear();
                const formatted = mm + '/' + dd + '/' + yyyy;
                return formatted;
            }, 
            sortable: true, filterable: true,
            sortComparator: (v1, v2) => {
                const t1 = v1 ? new Date(v1).getTime() : -Infinity;
                const t2 = v2 ? new Date(v2).getTime() : -Infinity;
                return t1 - t2;
            }},   
        hearingTime: { field: 'hearingTime', headerName: 'Hearing Time', flex: 1.5, minWidth: 130, resizable: true, hideable: true },
        hearingResults: { field: 'hearingResults', headerName: 'Hearing Results', flex: 1.8, minWidth: 140, resizable: true, hideable: true },
        court: { field: 'court', headerName: 'Court', flex: 1, minWidth: 100, resizable: true, hideable: true },
        courtCaseNumber: { field: 'courtCaseNumber', headerName: 'Court Case Number', flex: 2.2, minWidth: 160, resizable: true, hideable: true },
        judge: { field: 'judge', headerName: 'Judge', flex: 1, minWidth: 100, resizable: true, hideable: true },
        finalOrderDlvdToJudge: { field: 'finalOrderDlvdToJudge', headerName: 'Final Order Dlvd to Judge', 
            flex: 3, minWidth: 200, resizable: true, hideable: true, type: 'date', 
            valueGetter: (value, row) => {
                const raw = row?.finalOrderDlvdToJudge;
                if (!raw) return null;
                const dt = new Date(raw);
                return Number.isNaN(dt.getTime()) ? null : dt;
            },
            valueFormatter: (value) => {
                if (!value) return '';
                const d = value instanceof Date ? value : new Date(value);
                const mm = String(d.getMonth() + 1).padStart(2, '0');
                const dd = String(d.getDate()).padStart(2, '0');
                const yyyy = d.getFullYear();
                const formatted = mm + '/' + dd + '/' + yyyy;
                return formatted;
            }, 
            sortable: true, filterable: true,
            sortComparator: (v1, v2) => {
                const t1 = v1 ? new Date(v1).getTime() : -Infinity;
                const t2 = v2 ? new Date(v2).getTime() : -Infinity;
                return t1 - t2;
            }},   
        finalOrderSignedByJudge: { field: 'finalOrderSignedByJudge', headerName: 'Final Order Signed by Judge', flex: 3.2, minWidth: 220, resizable: true, hideable: true, type: 'date', 
            valueGetter: (value, row) => {
                const raw = row?.finalOrderSignedByJudge;
                if (!raw) return null;
                const dt = new Date(raw);
                return Number.isNaN(dt.getTime()) ? null : dt;
            },
            valueFormatter: (value) => {
                if (!value) return '';
                const d = value instanceof Date ? value : new Date(value);
                const mm = String(d.getMonth() + 1).padStart(2, '0');
                const dd = String(d.getDate()).padStart(2, '0');
                const yyyy = d.getFullYear();
                const formatted = mm + '/' + dd + '/' + yyyy;
                return formatted;
            }, 
            sortable: true, filterable: true,
            sortComparator: (v1, v2) => {
                const t1 = v1 ? new Date(v1).getTime() : -Infinity;
                const t2 = v2 ? new Date(v2).getTime() : -Infinity;
                return t1 - t2;
            }},   
        hearingNotes: { field: 'hearingNotes', headerName: 'Hearing Notes', flex: 1.5, minWidth: 130, resizable: true, hideable: true }
    }), [selectedRows, resultsQueued, handleSelectAll, handleRowSelection]);

    useEffect(() => {
    setResultsQueued(prevRows => 
        prevRows.map(row => ({
            ...row,
            autoEndWF: selectedRows.includes(row.id) ? 1 : 0
        }))
    );
}, [selectedRows]);

    // Column configuration for each view
    const columnConfigurations = useMemo(() => ({
        workflow: [
                'caseNumber', 'ytracCaseID', 'lastAction', 'lastActionDate', 'lastActionUser', 
                'lockUserLoginName', 'lockedLocation', 'caseWorkflowID', 'workflowName', 
                'departmentName', 'workflowStepName', 'standardWorkTimeEst', 'stepPriority', 
                'nextStepDueDateOnly', 'daysPastDue', 'timeAllowedInQueue', 'timeRemaining', 
                'workedOnTime', 'autoEndWF'
        ],
        legal: [
                'caseNumber', 'caseWorkflowID', 'currentAttorney', 'currentLegalSpecialist', 'NCPName','legalActionType', 
                'legalStatusReview', 'reviewResult', 'reviewNotes', 'legalWorkflowOpened', 'legalRefApprovedRejected',
                'pleadingsPrepSentToAtty', 'pleadingsApprSignedByAtty', 'deliveredToClerkForFiling',
                'dateFiledWithClerk', 'dlvdForServiceOfProcess', 'serviceType', 'dateOfServiceFailure',
                'serviceResults', 'hearingType', 'hearingDate', 'hearingTime', 'hearingResults',
                'court', 'courtCaseNumber', 'judge', 'finalOrderDlvdToJudge', 'finalOrderSignedByJudge',
                'hearingNotes'
        ],
         walkin: [
                'caseNumber', 'contactID', 'stepPriority', 'workflowName', 'departmentName', 
                'lockUserLoginName', 'lockedLocation', 'workflowStepName', 'nextStepDueTS',
                 'waitTimeSeconds', 'lastAction', 'lastActionDate', 'lastActionUser', 
                 'contactRole', 'contactFirstName', 'contactLastName', 'caseTypeName', 'jurisdiction' //, 
                //'caseWorkflowID'        
        ]
    }), []);

    // Function to get columns based on active tab
    const getColumnsForView = useCallback((viewIndex) => {
        let columnKeys;
        switch(viewIndex) {
            case 0: // Workflow View
                columnKeys = columnConfigurations.workflow;
                break;
            case 1: // Legal View
                columnKeys = columnConfigurations.legal;
                break;
            case 2: // WalkIn View
                columnKeys = columnConfigurations.walkin;
                break;
            default:
                columnKeys = columnConfigurations.workflow;
        }
        return columnKeys.map(key => allGridColumns[key]).filter(Boolean);
    }, [allGridColumns, columnConfigurations]);

    // Get current columns based on active tab
    // const currentColumns = useMemo(() => getColumnsForView(activeTab), [activeTab, getColumnsForView]);

    // Make sure selectedRows is in the component dependencies
    //const currentColumns = useMemo(() => getColumnsForView(activeTab), [activeTab, getColumnsForView, selectedRows]);

    // Add logging to see when columns update:
    const currentColumns = useMemo(() => {
        // console.log('Columns recalculated, selectedRows:', selectedRows.length);
        return getColumnsForView(activeTab);
    }, [activeTab, getColumnsForView, selectedRows, restoreCompleted]);

    const checkboxSetFilterOperator = useMemo(() => ({
        label: 'is any of (checkbox)',
        value: 'isAnyOfCheckbox',
        getApplyFilterFn: (filterItem) => {
            if (!filterItem?.field || !Array.isArray(filterItem.value) || filterItem.value.length === 0) {
                return null;
            }

            const selected = new Set(filterItem.value.map((value) => String(value)));

            return (cellValue) => selected.has(String(cellValue ?? ''));
        },
        InputComponent: CheckboxSetFilterInput
    }), []);

    const stringFilterOperators = useMemo(() => {
        const baseOperators = getGridStringOperators();
        const alreadyExists = baseOperators.some((operator) => operator.value === checkboxSetFilterOperator.value);
        return alreadyExists ? baseOperators : [...baseOperators, checkboxSetFilterOperator];
    }, [checkboxSetFilterOperator]);

    const currentColumnsWithCheckboxFilters = useMemo(() => (
        currentColumns.map((column) => {
            if (!column?.filterable || column?.field === 'autoEndWF') {
                return { ...column, pinnable: true };
            }

            const columnType = column?.type ?? 'string';
            if (columnType !== 'string') {
                return { ...column, pinnable: true };
            }

            return {
                ...column,
                pinnable: true,
                filterOperators: stringFilterOperators
            };
        })
    ), [currentColumns, stringFilterOperators]);

    const [alertProps, setAlertProps] = useState({
        type: '',
        message: '',
        open: false,
    });
     
    const handleAlertClose = () => {
        setAlertProps((prevState) => ({ ...prevState, open: false }));
    };

    const showAlert = (type, message) => {
        setAlertProps({ type, message, open: true });
    };

    // eslint-disable-next-line no-unused-vars
    const [selectedRowData, setSelectedRowData] = useState(null);

    const [hasInitializedDates, setHasInitializedDates] = useState(false);

    const [cachedInitialDate, setCachedInitialDate] = useState(null);

    useEffect(() => {
    if (hasInitializedDates) return; // Prevent multiple executions
    
    const initializeDefaultDates = async () => {
        try {
            const initialDate = await getInitialDateFromApi(initialInfoParams);
            const today = getTodayDate();
            setCachedInitialDate(initialDate);
            
            dispatchFormData({ 
                startDateTxt: initialDate, 
                endDateTxt: today, 
                hasValidDateData: true 
            });
            
            setHasInitializedDates(true);
        } catch (error) {
            // Handle error
            const today = getTodayDate();
            setCachedInitialDate(today); // Fallback
            dispatchFormData({ 
                startDateTxt: today, 
                endDateTxt: today, 
                hasValidDateData: true 
            });
        }
    };

    initializeDefaultDates();
}, [hasInitializedDates]);

    //=======================================================================
    //  - Begin
    //=======================================================================

    const getDateValidationMessage = (startDate, endDate) => {

        if (!startDate || !endDate) {
            return 'Start Date and End Date are required.';
        }

        const validStartDate = ValidationUtility.ValidateStartDate(startDate, endDate);
        const validEndDate = ValidationUtility.ValidateEndDate(startDate, endDate);
        if (!validStartDate.hasValidData || !validEndDate.hasValidData) {
            if (startDate > endDate) {
                return 'Start Date must be on or before End Date.';
            }
            return validStartDate.validationMessage || validEndDate.validationMessage || 'Please enter a valid date and search again';
        }

        // if (startDate > today || endDate > today) {
        //     return 'Start Date and End Date cannot be later than current date.';
        // }

        if (!isBusinessDate(startDate) || !isBusinessDate(endDate)) {
            return 'Start Date and End Date cannot be weekends or site holidays.';
        }

        return '';
    };

    const getQueuedActionDateValue = (row) => {
        const rawDate = row?.actionQueued || row?.actionQueuedTime || row?.ActionQueuedTime || row?.actionQueuedTS;
        const timestamp = Date.parse(rawDate);
        return Number.isNaN(timestamp) ? 0 : timestamp;
    };

    const normalizeQueuedRows = (apiResults) => {
        if (!Array.isArray(apiResults)) {
            return [];
        }

        const objectRows = apiResults.filter((item) => item && typeof item === 'object' && !Array.isArray(item));
        // if (objectRows.length > 0) {
            return objectRows;
        // }

        // const objectRows = apiResults.filter((item) => item && typeof item === 'object' && !Array.isArray(item));
        // if (objectRows.length > 0) {
        //     return objectRows;
        // }
        // 
        // const nestedArray = apiResults.find(Array.isArray);
        // if (!nestedArray) {
        //     return [];
        // }

        // return nestedArray.filter((item) => item && typeof item === 'object' && !Array.isArray(item));
    };

    const formatDurationFromSeconds = (secondsValue) => {
        const totalSeconds = Number(secondsValue);

        if (!Number.isFinite(totalSeconds)) {
            return '';
        }

        const absoluteSeconds = Math.abs(totalSeconds);
        const hours = Math.floor(absoluteSeconds / 3600);
        const minutes = Math.floor((absoluteSeconds % 3600) / 60);
        const seconds = absoluteSeconds % 60;
        const sign = totalSeconds < 0 ? '-' : '';

        return `${sign}${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`;
    };

    const formatVariancePercent = (workSecondsValue, standardSecondsValue) => {
        const workSeconds = Number(workSecondsValue);
        const standardSeconds = Number(standardSecondsValue);

        if (!Number.isFinite(workSeconds) || !Number.isFinite(standardSeconds) || standardSeconds === 0) {
            return '';
        }

        // Round to nearest whole percent for consistency across the app
        const percent = ((workSeconds - standardSeconds) / standardSeconds) * 100;
        return `${Math.round(percent)}%`;
    };

    const mapQueuedActionRow = (item, index) => {
        const rowId = index + 1;
        return {
        id: rowId,  // 0-based ID 
        caseNumber: item.caseNumber || '',
        ytracCaseID: item.ytracCaseID || '',
        lastAction: item.lastAction || '',
        lastActionDate: UtilityLibrary.formatDate(item.lastActionDate, "MM/DD/YYYY") || '', // type: 'date'
        //lastActionDate: UtilityLibrary.formatDate(item.lastActionDate, "YYYY-MM-DD") || '', // type: 'date'
        lastActionUser: item.lastActionUser || '',
        lockUserLoginName: item.lockUserLoginName || '',
        lockedLocation: item.lockedLocation || '',
        caseWorkflowID: item.caseWorkflowID || '',
        workflowName: item.workflowName || '',
        departmentName: item.departmentName || '',
        workflowStepName: item.workflowStepName || '',
        standardWorkTimeEst: item.standardWorkTimeEst || 0, // type: 'number'
        stepPriority: item.stepPriority || 0, // type: 'number'
        nextStepDueDateOnly: UtilityLibrary.formatDate(item.nextStepDueDateOnly, "MM/DD/YYYY") || '', // type: 'date'
        //nextStepDueTS: UtilityLibrary.formatDate(item.nextStepDueTS, "YYYY-MM-DD") || '', // type: 'date'
        daysPastDue: item.daysPastDue || 0, // type: 'number'
        timeAllowedInQueue: item.timeAllowedInQueue || 0, // type: 'number'
        timeRemaining: item.timeRemaining || 0, // type: 'number'
        workedOnTime: item.workedOnTime || 0, // type: 'number'
        autoEndWF: selectedRows.includes(rowId) ? 1 : 0  // 1 = checked, 0 = unchecked
        }
    };

    const mapLegalActionRow = (item, index) => {
        const rowId = index + 1;
        return {
        id: rowId,  // 0-based ID 
        caseNumber: item.caseNumber || '',
        caseWorkflowID: item.workflowNumber || item.WorkflowNumber || item.caseWorkflowID || '',
        currentAttorney: item.currentAttorney || item.CurrentAttorney || item.attorney || '',
        currentLegalSpecialist: item.currentLegalSpecialist || item.CurrentLegalSpecialist || item.legalSpecialist || '',
        legalActionType: item.legalActionType || item.LegalActionType || '',
        legalStatusReview: item.legalStatusReview || item.LegalStatusReview || item.reviewResult || '',
        reviewResult: item.reviewResult || item.ReviewResult || '',
        reviewNotes: item.reviewNotes || item.ReviewNotes || '',
        legalWorkflowOpened: UtilityLibrary.formatDate(item.workflowOpenedTS, "MM/DD/YYYY") || '', // item.legalWorkflowOpened || item.LegalWorkflowOpened || 
        legalRefApprovedRejected: UtilityLibrary.formatDate(item.refAppRejTS, "MM/DD/YYYY") || '', // item.legalRefApprovedRejected || item.LegalRefApprovedRejected || 
        pleadingsPrepSentToAtty: UtilityLibrary.formatDate(item.pleadingsPrepSentTS, "MM/DD/YYYY") || '', // item.pleadingsPrepSentToAtty || item.PleadingsPrepSentToAtty || 
        pleadingsApprSignedByAtty: UtilityLibrary.formatDate(item.pleadingsAppSignedTS, "MM/DD/YYYY") || '', // tem.pleadingsApprSignedByAtty || item.PleadingsApprSignedByAtty || 
        deliveredToClerkForFiling: UtilityLibrary.formatDate(item.deliverToClerkTS, "MM/DD/YYYY") || '', //item.deliveredToClerkForFiling || item.DeliveredToClerkForFiling || 
        dateFiledWithClerk: UtilityLibrary.formatDate(item.fileWithClerkTS, "MM/DD/YYYY") || '', // item.dateFiledWithClerk || item.DateFiledWithClerk ||
        dlvdForServiceOfProcess: UtilityLibrary.formatDate(item.processServMailTS, "MM/DD/YYYY") || '', // item.dlvdForServiceOfProcess || item.DlvdForServiceOfProcess || 
        serviceType: item.serviceType || item.ServiceType || '',
        dateOfServiceFailure: UtilityLibrary.formatDate(item.serviceFailureTS, "MM/DD/YYYY") || '', // item.dateOfServiceFailure || item.DateOfServiceFailure || 
        serviceResults: item.serviceResults || item.ServiceResults || item.serviceResult || '',
        hearingType: item.hearingType || item.HearingType || item.courtHearingType || '',
        hearingDate: UtilityLibrary.formatDate(item.courtHearingDateOnly, "MM/DD/YYYY") || '', // item.hearingDate || item.HearingDate || item.courtHearingDateOnly || 
        hearingTime: item.hearingTime || item.HearingTime || item.courtHearingTimeOnly || '',
        hearingResults: item.hearingResults || item.HearingResults || item.courtHearingResult || '',
        court: item.court || item.Court || '',
        courtCaseNumber: item.courtCaseNumber || item.CourtCaseNumber || item.courtNumber || '',
        judge: item.judge || item.Judge || '',
        finalOrderDlvdToJudge: UtilityLibrary.formatDate(item.orderDeliveredTS, "MM/DD/YYYY") || '', // item.finalOrderDlvdToJudge || item.FinalOrderDlvdToJudge || 
        finalOrderSignedByJudge: UtilityLibrary.formatDate(item.orderSignedTS, "MM/DD/YYYY") || '', // item.finalOrderSignedByJudge || item.FinalOrderSignedByJudge || 
        hearingNotes: item.hearingNotes || item.HearingNotes || ''
        }
    };

    const mapWalkInActionRow = (item, index) => {
        const rowId = index + 1;
        return {
        id: rowId,  // 0-based ID 
        caseNumber: item.caseNumber || '',
        ytracCaseID: item.ytracCaseID || '',
        contactID: item.contactID || '',
        stepPriority: item.stepPriority || 0, // type: 'number'
        // caseWorkflowID: item.caseWorkflowID || '', 
        workflowName: item.workflowName || '',
        departmentName: item.departmentName || '',
        lockUserLoginName: item.lockUserLoginName || '',
        lockedLocation: item.lockedLocation || '',      
        workflowStepName: item.workflowStepName || '',
        nextStepDueTS: UtilityLibrary.formatDate(item.nextStepDueTS, "MM/DD/YYYY") || '', // type: 'date'
        //nextStepDueTS: UtilityLibrary.formatDate(item.nextStepDueTS, "YYYY-MM-DD") || '', // type: 'date'
        waitTimeSeconds: item.waitTimeSeconds || 0, // type: 'number'
        lastAction: item.lastAction || '',
        lastActionDate: UtilityLibrary.formatDate(item.lastActionDate, "MM/DD/YYYY") || '', // type: 'date'
        //lastActionDate: UtilityLibrary.formatDate(item.lastActionDate, "YYYY-MM-DD") || '', // type: 'date'
        lastActionUser: item.lastActionUser || '',    
        
        contactRole: item.contactRole || '', // type: 'string'
        contactFirstName: item.contactFirstName || '', // type: 'string'
        contactLastName: item.contactLastName || '', // type: 'string'
        caseTypeName: item.caseTypeName || '', // type: 'string'
        jurisdiction: item.jurisdiction || '' // type: 'string'
        }
    };

    const applyClientFilters = (rows, formData = searchFormData, includeSystemActionRows = includeSystemActions) => {
        let filteredRows = rows;

        if (formData.caseSearchTxt) {
            const caseSearchValue = formData.caseSearchTxt.trim().toLowerCase();
            filteredRows = filteredRows.filter((row) =>
                (row.caseNumber || '').trim().toLowerCase() === caseSearchValue
            );
        }

        if (Array.isArray(formData.workflowSelect) && formData.workflowSelect.length > 0) {
            filteredRows = filteredRows.filter((row) => formData.workflowSelect.includes(row.workflow));
        }

        if (Array.isArray(formData.queueSelect) && formData.queueSelect.length > 0) {
            filteredRows = filteredRows.filter((row) => formData.queueSelect.includes(row.queue));
        }

        return [...filteredRows].sort((a, b) => getQueuedActionDateValue(b) - getQueuedActionDateValue(a));
    };

    const buildQueuedSearchPayload = (formData = searchFormData) => {
        const activeModuleID = activeTab === 0 ? 1 : activeTab === 1 ? 2 : 3;
        // Determine which department IDs to use
        // let departmentIDs;

        // if (formData.queueSelect.length === 0) {
        //     // No queues selected - use all available queues in these cases:
        //     // 1. No workflows selected AND no queues selected (show everything)
        //     // 2. Workflows selected AND no queues selected (show all queues for selected workflows)
        //     //departmentIDs = queueOptions.map(option => option.value).join('|');
        //     departmentIDs = queueOptions
        //     .filter(option => option.value !== 'All')
        //     .map(option => option.value)
        //     .join('|');
        //     } 
        // else {
        //     // Use specifically selected queues
        //     departmentIDs = formData.queueSelect.join('|');
        // }

        const selectableWorkflowValues = workflowOptions
        .filter((option) => option.value !== 'All')
        .map((option) => option.value);

        const selectableQueueValues = queueOptions
            .filter((option) => option.value !== 'All')
            .map((option) => option.value);

        const selectedWorkflowSet = new Set(formData.workflowSelect || []);
        const selectedQueueSet = new Set(formData.queueSelect || []);

        const allWorkflowsSelected =
            selectableWorkflowValues.length > 0 &&
            selectableWorkflowValues.every((value) => selectedWorkflowSet.has(value));

        const allQueuesSelected =
            selectableQueueValues.length > 0 &&
            selectableQueueValues.every((value) => selectedQueueSet.has(value));

        const selectedQueueCount = selectedQueueSet.size;

        let departmentIDs = '';

        // Only force -999 when all workflows + all queues + queue count > 250
        if (allWorkflowsSelected && allQueuesSelected){
            departmentIDs = '-999';
        } 
        // else if (selectedQueueCount > 250) {
        //     showAlert('error', `Selected queue count (${selectedQueueCount}) exceeds the maximum allowed (250). Please refine your selection.`);
        // }
        else if (selectedQueueSet.size === 0) {
            // existing behavior
            departmentIDs = selectableQueueValues.join('|');
        } 
        else {
            // existing behavior
            departmentIDs = Array.from(selectedQueueSet).join('|');
        }

        const addOneDayToYyyyMmDd = (dateText) => {
            if (!dateText) return "";
            const parts = dateText.split("-").map(Number);
            const dt = new Date(parts[0], parts[1] - 1, parts[2]); // local midnight
            dt.setDate(dt.getDate() + 1);

            const yyyy = dt.getFullYear();
            const mm = String(dt.getMonth() + 1).padStart(2, "0");
            const dd = String(dt.getDate()).padStart(2, "0");
            return yyyy + "-" + mm + "-" + dd;
        };

        const nextActionDueDateEndExclusive = addOneDayToYyyyMmDd(formData.endDateTxt);

        return {
            DepartmentIDs: departmentIDs,
            CaseNumber: searchFormData.caseSearchTxt.trim() || "",
            UserLoginID: loginLegacyUserID,
            MasterServerDBSchema: masterServerDBSchema,
            YTracSiteID: loginStateID,
            BoardedSiteID: loginSiteID,
            ModuleID: 1,
            WorkflowStateLockoutTimer: stateWorkflowLockoutTime,
            PageNumber: 1,
            PageRowCount: 25000,
            NextActionDueDateStart: searchFormData.startDateTxt,
            //NextActionDueDateEnd: searchFormData.endDateTxt,
            NextActionDueDateEnd: nextActionDueDateEndExclusive,
            SystemTimeZoneName: timeZone
        };
    };

    const handleSearchQueuedClick = async () => {
        const activeFormData = searchFormData;
        //const activeIncludeSystemActions = includeSystemActions;

        const isValidCaseFormat = await checkCaseNumberRegEx(activeFormData.caseSearchTxt);
        if (!isValidCaseFormat) {
            dispatchFormData({ hasValidCaseData: false });
            showAlert('error', caseNumberRegex?.caseRegexMessage || 'Invalid case number format.');
            return;
        }

        dispatchFormData({ hasValidCaseData: true });
        const validationMessage = getDateValidationMessage(activeFormData.startDateTxt, activeFormData.endDateTxt);
        if (validationMessage) {
            dispatchFormData({ hasValidDateData: false });
            showAlert('error', validationMessage);
            return;
        }

        dispatchFormData({ hasValidDateData: true });
        setIsPageLoading(true);

        try {
            const searchPayload = buildQueuedSearchPayload(activeFormData);
            const queuedSearchResponse = await ApiManager.GetActiveWorkflowWorkList(searchPayload);
            //const queuedSearchResponse = await ApiManager.SearchQueuedActions(searchPayload);
            //queueSelectedData = await ApiManager.GetActiveWorkflowWorkList(workParams);
            // const normalizedRows = normalizeQueuedRows(queuedSearchResponse?.items);
            // const mappedRows = normalizedRows.map(mapQueuedActionRow);
            //const filteredRows = applyClientFilters(mappedRows, activeFormData, false);
            setSelectedRows([]);

            setPaginationModel((currentModel) => ({ ...currentModel, page: 0 }));
            //setAllQueuedRows(queuedSearchResponse?.items || []);
            //setAllQueuedRows(mappedRows);
            //setResultsQueued(filteredRows);
            //setResultsQueued(applyClientFilters(mappedRows, activeFormData, false));
            //setResultsQueued(queuedSearchResponse?.items || []);
            //const processedRows = normalizedRows.map(mapQueuedActionRow);

            //setAllQueuedRows(queuedSearchResponse);   // Store all processed rows
            //setResultsQueued(mappedRows);   // Display all processed rows

            
            //console.log('Results length:', resultsQueued.length);
            //console.log('AllQueuedRows:', allQueuedRows);
            //showAlert('info', `Total all queued rows loaded: ${allQueuedRows.length}`);

            // const rowsWithIds = (queuedSearchResponse?.items || []).map((item, index) => ({
            //     ...item,
            //     id: item.id || item.caseWorkflowID || item.workflowID || item.ytracCaseID || `row-${index}`
            // }));

            // setResultsQueued(rowsWithIds);

            const normalizedRows = normalizeQueuedRows(queuedSearchResponse);
            const processedRows = normalizedRows.map(mapQueuedActionRow);


            setResultsQueued(processedRows);
            // const filteredRows = applyClientFilters(processedRows, activeFormData);
            // setResultsQueued(filteredRows);

            // showAlert('info', `Total results queued rows loaded: ${normalizedRows.length || 0}`);

        }
        catch (error) {
            await LoggerUtility.ManageErrorLogging(error, errorFormName, 'handleSearchQueuedClick');
            showAlert('error', 'Unable to search queued actions right now. Please try again.');
            setAllQueuedRows([]);
            setResultsQueued([]);
        }
        finally {
            setIsPageLoading(false);
            setHasSearched(true);
            hasSearchedByTab.current[activeTab] = true;
        }
    };

    const buildWalkInSearchPayload = (formData = searchFormData) => {
        const activeModuleID = activeTab === 0 ? 1 : activeTab === 1 ? 2 : 3;
        // Determine which department IDs to use
        let DepartmentID = '-999'; // Default to all departments if none selected
        
        return {
            DepartmentID: DepartmentID,
            UserLoginID: loginLegacyUserID,
            MasterServerDBSchema: masterServerDBSchema,
            YTracSiteID: loginStateID,
            BoardedSiteID: loginSiteID,
            ModuleID: 1,
            WorkflowStateLockoutTimer: stateWorkflowLockoutTime,
            SystemTimeZoneName: timeZone
        };
    };

    const handleSearchWalkInClick = async () => {
        const activeFormData = searchFormData;
        // //const activeIncludeSystemActions = includeSystemActions;

        // const isValidCaseFormat = await checkCaseNumberRegEx(activeFormData.caseSearchTxt);
        // if (!isValidCaseFormat) {
        //     dispatchFormData({ hasValidCaseData: false });
        //     showAlert('error', caseNumberRegex?.caseRegexMessage || 'Invalid case number format.');
        //     return;
        // }

        // dispatchFormData({ hasValidCaseData: true });
        // const validationMessage = getDateValidationMessage(activeFormData.startDateTxt, activeFormData.endDateTxt);
        // if (validationMessage) {
        //     dispatchFormData({ hasValidDateData: false });
        //     showAlert('error', validationMessage);
        //     return;
        // }

        // dispatchFormData({ hasValidDateData: true });
        setIsPageLoading(true);
        // console.log('Calling handleSearchWalkInClick: ' + Date());
        try {
            const searchPayload = buildWalkInSearchPayload(activeFormData);
            const walkInSearchResponse = await ApiManager.GetActiveWorkflowWalkInList(searchPayload);

            setSelectedRows([]);

            setPaginationModel((currentModel) => ({ ...currentModel, page: 0 }));

            const normalizedRows = normalizeQueuedRows(walkInSearchResponse);
            const processedRows = normalizedRows.map(mapWalkInActionRow);

            setResultsQueued(processedRows);

        }
        catch (error) {
            await LoggerUtility.ManageErrorLogging(error, errorFormName, 'handleSearchWalkInClick');
            showAlert('error', 'Unable to search walk-in actions right now. Please try again.');
            setAllQueuedRows([]);
            setResultsQueued([]);
        }
        finally {
            setIsPageLoading(false);
            setHasSearched(true);
            hasSearchedByTab.current[activeTab] = true;
            setInterval(() => {}, 0); // Reset interval to prevent multiple timers
            // console.log('End handleSearchWalkInClick: ' + Date());
        }
    };

    useEffect(() => {
        if (activeTab !== 2 || refreshInterval <= 0) return; // only Walk-In tab
        const intervalMs = Number(refreshInterval) * 1000;

        const timerId = setInterval(() => {
            handleSearchWalkInClick();
        }, intervalMs);

        return () => clearInterval(timerId); // cleanup on unmount/interval change/tab change
    }, [activeTab, refreshInterval, handleSearchWalkInClick]);

    const buildLegalSearchPayload = (formData = searchFormData) => {
        const activeModuleID = activeTab === 0 ? 1 : activeTab === 1 ? 2 : 3;

        return {
            MasterServerDBSchema: masterServerDBSchema,
            BoardedSiteID: loginSiteID,
            ModuleID: 1,
            WorkflowStateLockoutTimer: stateWorkflowLockoutTime,
            SystemTimeZoneName: timeZone
        };
    };

    const handleSearchLegalClick = async () => {
        const activeFormData = searchFormData;

        const isValidCaseFormat = await checkCaseNumberRegEx(activeFormData.caseSearchTxt);
        if (!isValidCaseFormat) {
            dispatchFormData({ hasValidCaseData: false });
            showAlert('error', caseNumberRegex?.caseRegexMessage || 'Invalid case number format.');
            return;
        }

        dispatchFormData({ hasValidCaseData: true });
        const validationMessage = getDateValidationMessage(activeFormData.startDateTxt, activeFormData.endDateTxt);
        if (validationMessage) {
            dispatchFormData({ hasValidDateData: false });
            showAlert('error', validationMessage);
            return;
        }

        dispatchFormData({ hasValidDateData: true });
        setIsPageLoading(true);

        try {
            const searchPayload = buildLegalSearchPayload(activeFormData);
            const legalSearchResponse = await ApiManager.GetActiveWorkflowLegalList(searchPayload);

            setSelectedRows([]);

            setPaginationModel((currentModel) => ({ ...currentModel, page: 0 }));

            const normalizedRows = normalizeQueuedRows(legalSearchResponse);
            const processedRows = normalizedRows.map(mapLegalActionRow);

            setResultsQueued(processedRows);

        }
        catch (error) {
            await LoggerUtility.ManageErrorLogging(error, errorFormName, 'handleSearchLegalClick');
            showAlert('error', 'Unable to search legal actions right now. Please try again.');
            setAllQueuedRows([]);
            setResultsQueued([]);
        }
        finally {
            setIsPageLoading(false);
            setHasSearched(true);
            hasSearchedByTab.current[activeTab] = true;
            setShowLegalHint(false);  // ← hide hint after refresh completes
        }
    };

    const setDateValidationMessage = (startDate, endDate) => {
        const validationMessage = getDateValidationMessage(startDate, endDate);
        dispatchFormData({ hasValidDateData: validationMessage === '' });
    }

    const handleStartDatePickerChange = (dateValue) => {
        const selectedDateText = dateValue ? formatDateForInput(dateValue) : '';
        dispatchFormData({ startDateTxt: selectedDateText });
        setDateValidationMessage(selectedDateText, searchFormData.endDateTxt);
    };

    const handleEndDatePickerChange = (dateValue) => {
        const selectedDateText = dateValue ? formatDateForInput(dateValue) : '';
        dispatchFormData({ endDateTxt: selectedDateText });
        setDateValidationMessage(searchFormData.startDateTxt, selectedDateText);
    };

    const handleStartDateClear = (event) => {
        event.preventDefault();
        event.stopPropagation();
        dispatchFormData({ startDateTxt: '' });
        setDateValidationMessage('', searchFormData.endDateTxt);
    };

    const handleEndDateClear = (event) => {
        event.preventDefault();
        event.stopPropagation();
        dispatchFormData({ endDateTxt: '' });
        setDateValidationMessage(searchFormData.startDateTxt, '');
    };

    const handleWorkflowSelectChange = (event, newValue, reason) => {
        if (reason === 'clear') {
            setWorkflowSelectedNone("NONE");
            setQueueSelectedNone("NONE");
            dispatchFormData({
                workflowSelect: [], 
                queueSelect: []});
            isClearingWorkflowRef.current = true
            setIsWorkflowOpen(true)   
            setTimeout(() => { isClearingWorkflowRef.current = false; }, 0)
            return;
        }
        
        // Get all selectable workflows (excluding "All")
        const allSelectableWorkflows = workflowOptions
            .filter(option => option.value !== 'All')
            .map(option => option.value);
        
        // Check if "All" option was clicked
        const allOptionClicked = Array.isArray(newValue) && 
                                newValue.some(option => option.value === 'All');
        
        // Check if all regular workflows were already selected before this click
        const allWereSelected = allSelectableWorkflows.length > 0 &&
                               allSelectableWorkflows.every(val => 
                                   searchFormData.workflowSelect.includes(val)
                               );
        
        let selectedValues = [];
        
        // Toggle logic: if "All" was clicked
        if (allOptionClicked) {
            if (allWereSelected) {
                // All were selected → click All again → deselect all
                selectedValues = [];
            } else {
                // Not all selected → click All → select all
                selectedValues = allSelectableWorkflows;
            }
        } else {
            // Regular multi-select: use clicked values, excluding "All"
            selectedValues = Array.isArray(newValue) 
                ? newValue
                    .map(option => option.value)
                    .filter(val => val !== 'All')
                : [];
        }
        
        // Handle empty selection
        if (selectedValues.length === 0) {
            setWorkflowSelectedNone("NONE");
            setQueueSelectedNone("NONE");
            dispatchFormData({
                workflowSelect: [],
                queueSelect: []
            });
            return;
        }
        
        setWorkflowSelectedNone("");
        setQueueSelectedNone("");
        dispatchFormData({
            workflowSelect: selectedValues,
            queueSelect: []
        });
    };

    const handleQueueSelectChange = (event, newValue) => {
        // Get all selectable queues (excluding "All")
        const allSelectableQueues = queueOptions
            .filter(option => option.value !== 'All')
            .map(option => option.value);
        
        // Check if "All" option was clicked
        const allOptionClicked = Array.isArray(newValue) && 
                                newValue.some(option => option.value === 'All');
        
        // Check if all regular queues were already selected before this click
        const allWereSelected = allSelectableQueues.length > 0 &&
                               allSelectableQueues.every(val => 
                                   searchFormData.queueSelect.includes(val)
                               );
        
        let selectedValues = [];
        
        // Toggle logic: if "All" was clicked
        if (allOptionClicked) {
            if (allWereSelected) {
                // All were selected, click All again, deselect all
                selectedValues = [];
            } else {
                // Not all selected, click All, select all
                selectedValues = allSelectableQueues;
            }
        } else {
            // Regular multi-select: use clicked values, excluding "All"
            selectedValues = Array.isArray(newValue) 
                ? newValue
                    .map(option => option.value)
                    .filter(val => val !== 'All')
                : [];
        }
        
        // Handle empty selection
        if (selectedValues.length === 0) {
            setQueueSelectedNone("NONE");
            dispatchFormData({ queueSelect: [] });
            return;
        }

        setQueueSelectedNone("");
        dispatchFormData({ queueSelect: selectedValues });
    };

    const checkCaseNumberRegEx = useCallback(async (caseNumber) => {
        try {
            let isValidFormat = true;
            const caseNumberRegexValue = new RegExp(caseNumberRegex.caseRegexValue || '');

            if (caseNumberRegex.caseRegexValue && caseNumber) {
                if (!caseNumberRegexValue.test(caseNumber)) {
                    if (activeCaseSearchRef && activeCaseSearchRef.setValidationMessage) {
                        activeCaseSearchRef.setValidationMessage(caseNumberRegex.caseRegexMessage || 'Invalid case number format');
                    }
                    setCaseNumberIconsDisabled({ search: true, copy: true, clear: false });
                    isValidFormat = false;
                }
            }

            if (isValidFormat) {
                if (activeCaseSearchRef && activeCaseSearchRef.setValidationMessage) {
                    activeCaseSearchRef.setValidationMessage('');
                }

                const hasCaseValue = Boolean(caseNumber);
                setCaseNumberIconsDisabled({ search: !hasCaseValue, copy: !hasCaseValue, clear: !hasCaseValue });
            }

            return isValidFormat;
        }
        catch (error) {
            throw LoggerUtility.ProcessErrorData(error, 'checkCaseNumberRegEx', {});
        }
    }, [activeCaseSearchRef, caseNumberRegex, setCaseNumberIconsDisabled]);

    const handleCaseSearchChange = async (event) => {
        try {
            const valueText = event.target.value;
            const isValidFormat = await checkCaseNumberRegEx(valueText);

            dispatchFormData({ caseSearchTxt: valueText, hasValidCaseData: isValidFormat });
        }
        catch (error) {
            await LoggerUtility.ManageErrorLogging(error, errorFormName, 'handleCaseSearchChange');
            dispatchFormData({ caseSearchTxt: event.target.value, hasValidCaseData: true });
        }
    };

    const handleCaseSearchClick = async () => {
        //await handleSearchQueuedClick();
        await handleSearchLegalClick();
    };

    const handleRefreshQueuedClick = async () => {
        await handleSearchQueuedClick();
    };

    const handleFilterKeyDown = async (event) => {
        if (event.key !== 'Enter') {
            return;
        }

        const isGridElement = event.target.closest('.MuiDataGrid-root');
        if (isGridElement) {
            return;
        }

        event.preventDefault();
        //await handleSearchQueuedClick();
        await handleSearchLegalClick();
    };

    const handleCaseSearchClear = () => {
        dispatchFormData({ caseSearchTxt: "", hasValidCaseData: true });
        setCaseNumberIconsDisabled({ search: true, copy: true, clear: true });
        if (activeCaseSearchRef && activeCaseSearchRef.setValidationMessage) {
            activeCaseSearchRef.setValidationMessage("");
        }
    };

    const handleRowDoubleClick = async (params, event) => {
        if (!(formFieldAccess.queueDoubleClickEvent?.hide ?? false)) {
            try {           
                setSelectedRowData(params.row); 
                      
                const actionOptionsSelectParams  = {
                    CaseWorkflowID: params.row.caseWorkflowID,
                    ModuleID: initialInfoParams.ModuleID,
                    UserLoginID: initialInfoParams.UserLoginID,
                    YTracSiteID: initialInfoParams.YTracSiteID,
                    MasterServerDBSchema: initialInfoParams.MasterServerDBSchema     
                };

                const actionOptionsCaseNumber = params.row.caseNumber.trim();

                const actionOptionsResults = await ApiManager.GetActionOptionsList(actionOptionsSelectParams);

                const userPermissions = SessionManager.GetDataFromSession("UserPermissions");

                if ((userPermissions.btnNext?.read || userPermissions.btnNext?.write) && actionOptionsResults?.length > 0) {  
                    setActivePage('nextWorkitem');
                    navigate('/nextworkitem', { state: { actionOptionsResults, actionOptionsCaseNumber } }); // Redirects to the Next Workitem component
                } 
                else
                { 
                    showAlert('error', 'The user does not have access to NEXT Page.');
                } 
                
            } catch (error) {
                setActivePage('queueWorkflow');
                navigate('./queueWorkflow'); // Redirects to the queueWorkflow component
            }
        } else {
            showAlert('error', 'Access denied.');
            return;
        }
    };

    const handleRowWalkInDoubleClick = async (params, event) => {
        if (!(formFieldAccess.walkInDoubleClickEvent?.hide ?? false)) {
            try {           
                setSelectedRowData(params.row); 
                      
                const actionOptionsSelectParams  = {
                    CaseWorkflowID: params.row.caseWorkflowID,
                    ModuleID: initialInfoParams.ModuleID,
                    UserLoginID: initialInfoParams.UserLoginID,
                    YTracSiteID: initialInfoParams.YTracSiteID,
                    MasterServerDBSchema: initialInfoParams.MasterServerDBSchema     
                };

                const actionOptionsCaseNumber = params.row.caseNumber.trim();

                const actionOptionsResults = await ApiManager.GetActionOptionsList(actionOptionsSelectParams);

                const userPermissions = SessionManager.GetDataFromSession("UserPermissions");

                if ((userPermissions.btnNext?.read || userPermissions.btnNext?.write) && actionOptionsResults?.length > 0) {  
                    setActivePage('nextWorkitem');
                    navigate('/nextworkitem', { state: { actionOptionsResults, actionOptionsCaseNumber } }); // Redirects to the Next Workitem component
                } 
                else
                { 
                    showAlert('error', 'The user does not have access to NEXT Page.');
                } 
                
            } catch (error) {
                setActivePage('queueWorkflow');
                navigate('./queueWorkflow'); // Redirects to the queueWorkflow component
            }
        } else {
            showAlert('error', 'Access denied.');
            return;
        }
    };

    const handleRowLegalDoubleClick = async (params, event) => {
        if (!(formFieldAccess.legalDoubleClickEvent?.hide ?? false)) {
            try {           
                setSelectedRowData(params.row); 
                      
                const actionOptionsSelectParams  = {
                    CaseWorkflowID: params.row.caseWorkflowID,
                    ModuleID: initialInfoParams.ModuleID,
                    UserLoginID: initialInfoParams.UserLoginID,
                    YTracSiteID: initialInfoParams.YTracSiteID,
                    MasterServerDBSchema: initialInfoParams.MasterServerDBSchema     
                };

                const actionOptionsCaseNumber = params.row.caseNumber.trim();

                const actionOptionsResults = await ApiManager.GetActionOptionsList(actionOptionsSelectParams);

                const userPermissions = SessionManager.GetDataFromSession("UserPermissions");

                if ((userPermissions.btnNext?.read || userPermissions.btnNext?.write) && actionOptionsResults?.length > 0) {  
                    setActivePage('nextWorkitem');
                    navigate('/nextworkitem', { state: { actionOptionsResults, actionOptionsCaseNumber } }); // Redirects to the Next Workitem component
                } 
                else
                { 
                    showAlert('error', 'The user does not have access to NEXT Page.');
                } 
                
            } catch (error) {
                setActivePage('queueWorkflow');
                navigate('./queueWorkflow'); // Redirects to the queueWorkflow component
            }
        } else {
            showAlert('error', 'Access denied.');
            return;
        }
    };

    const handleStartQAWorkflowClick = () => {
        showAlert('success', 'QA Workflow started!');
    };

    const handleFileNameChange = (event) => {
        setFileName(event.target.value);
    };

    const handleFormatChange = (event) => {
        setFormat(event.target.value);
    };

    const handleIncludeHeadersChange = (event) => {
        setIncludeHeaders(event.target.checked);
    };

    const handlePageSelectionChange = (event) => {
        setPageSelection(event.target.value);
    };

    const handleIncludeFiltersChange = (event) => {
        setIncludeFilters(event.target.checked);
    };

    const handleExportBtnClick = () => {
            //setFileName(getExportFileName());
            const defaultName = getExportFileName();
            setFileName(defaultName); // initial value shown in textbox
            setExportDialogOpen(true);
        };
    
        const handleExportDialogClose = () => {
            setExportDialogOpen(false);
        };
    
        const getScopeRowIds = () => {
            const allVisibleRowIds = typeof queuedGridApiRef.current?.getSortedRowIds === 'function'
                ? queuedGridApiRef.current.getSortedRowIds()
                : resultsQueued.map((row) => row.id);
    
            if (exportScope === 'currentPage') {
                const pageSize = paginationModelByTab[activeTab]?.pageSize || 100;
                const pageNum = paginationModelByTab[activeTab]?.page || 0;
                const startIndex = pageNum * pageSize;
                const endIndex = startIndex + pageSize;
                return allVisibleRowIds.slice(startIndex, endIndex);
            }
    
            return allVisibleRowIds;
        };
    
        const getExportFileName = () => {
            const tabNames = ['Workflow', 'Legal', 'Walk-In'];
            const tabName = tabNames[activeTab] || 'Queue';
            const user = sessionService.getUser() || {};
            const stateName = String(user.stateName || 'State').trim().replace(/\s+/g, '_');
            const siteName = String(user.siteName || 'Site').trim().replace(/\s+/g, '_');
            const now = new Date();
            const yyyymmdd = `${now.getFullYear()}${String(now.getMonth() + 1).padStart(2, '0')}${String(now.getDate()).padStart(2, '0')}`;
    
            return `${stateName}_${siteName}_${tabName}_Data_${yyyymmdd}`;
        };
    
        const handleExportExecute = async () => {
            try {
                const visibleFields = gridVisibleColumnFieldsSelector(queuedGridApiRef);

                const fieldsToExport = currentColumns.map((column) => column.field);

                // handleExportExecute
                const defaultName = getExportFileName();
                const typedName = (fileName || '').trim();

                // If user typed anything, use it.
                // If textbox is empty, fall back to default.
                const nameToUse = typedName.length > 0 ? typedName : defaultName;

                // Optional explicit mismatch check (same result):
                const isMismatch = typedName.length > 0 && typedName !== defaultName;
                const finalName = isMismatch ? typedName : nameToUse;

                const api = queuedGridApiRef?.current;

                if (!api) {
                    showAlert('error', 'Grid is not ready for export.');
                    return;
                }

                const unfilteredRowIds =
                    (typeof api.getSortedRowIds === 'function' && api.getSortedRowIds()) ||
                    (typeof api.getRowModels === 'function' && Array.from(api.getRowModels().keys())) ||
                    resultsQueued.map((row) => row.id);

                let filteredRowIds = unfilteredRowIds;
                if (api.state) 
                {
                    try {
                        filteredRowIds = gridFilteredSortedRowIdsSelector(queuedGridApiRef) || unfilteredRowIds;
                    } 
                    catch {
                        filteredRowIds = unfilteredRowIds;
                    }
                }

                let rowIdsToExport;
                let exportFields;
                let allColumnsFlag;

                if (includeFilters === true) {
                    if (pageSelection === 'all') 
                    {
                        rowIdsToExport = filteredRowIds;       // all rows, no filters applied
                        exportFields = visibleFields  // all columns
                        allColumnsFlag = false;
                    } 
                    else if (pageSelection === 'current' ) 
                    {
                        const source = filteredRowIds;
                        const pageSize = paginationModelByTab[activeTab]?.pageSize || 100;
                        const pageNum = paginationModelByTab[activeTab]?.page || 0;
                        const start = pageNum * pageSize;
                        rowIdsToExport = source.slice(start, start + pageSize);
                        exportFields = visibleFields;  // only visible columns
                        allColumnsFlag = false;
                    }
                } 
                else 
                {
                    // Unfiltered mode: use pageSelection to decide rows
                    if (pageSelection === 'all') 
                    {
                        rowIdsToExport = unfilteredRowIds;       // all rows, no filters applied
                        exportFields = currentColumns.map(col => col.field);  // all columns
                        allColumnsFlag = pageSelection === 'all' ? true : false;
                    } 
                    else if (pageSelection === 'current' ) 
                    {
                        const source = unfilteredRowIds;
                        const pageSize = paginationModelByTab[activeTab]?.pageSize || 100;
                        const pageNum = paginationModelByTab[activeTab]?.page || 0;
                        const start = pageNum * pageSize;
                        rowIdsToExport = source.slice(start, start + pageSize);
                        exportFields = currentColumns.map(col => col.field);  // all columns
                        allColumnsFlag = pageSelection === 'current' ? true : false;
                    }
                }

                const exportOptions = {
                    csv: () => queuedGridApiRef.current.exportDataAsCsv({
                        fileName: finalName,
                        includeHeaders: includeHeaders,
                        fields: exportFields,
                        allColumns: allColumnsFlag,
                        includeFilters: includeFilters,
                        getRowsToExport: () => rowIdsToExport
                    }),
                    
                    excel: () => queuedGridApiRef.current.exportDataAsExcel({
                        fileName: finalName,
                        includeHeaders: includeHeaders,
                        fields: exportFields,
                        allColumns: allColumnsFlag,
                        includeFilters: includeFilters,
                        getRowsToExport: () => rowIdsToExport
                    }),

                    // pdf: () => queuedGridApiRef.current.exportDataAsPdf({
                    //     fileName: finalName,
                    //     includeHeaders: includeHeaders,
                    //     fields: exportFields,
                    //     allColumns: allColumnsFlag,
                    //     includeFilters: includeFilters,
                    //     getRowsToExport: () => rowIdsToExport
                    // }),
                };

                if (format === 'csv') {
                    exportOptions.csv();
                    showAlert('success', 'CSV export initiated!');
                    } 
                else if (format === 'excel') {
                    exportOptions.excel();
                    showAlert('success', 'Excel export initiated!');
                    } 
                // else if (format === 'pdf') {
                //     exportOptions.pdf();
                //     showAlert('success', 'PDF export initiated!');
                //     } 
                else {
                    showAlert('error', 'Please select a valid export format.');
                    return;
                }
            } catch (error) {
                await LoggerUtility.ManageErrorLogging(error, errorFormName, 'handleExportExecute');
                showAlert('error', `Unable to export data the selected file to format ${format}. Please try again or chose a different format.`);
            } finally {
                setExportDialogOpen(false);
            }
        };

    const handleGridKeyDown = (event) => {
        // Enhanced keyboard navigation
        if (event.key === 'Enter' || event.key === ' ') {
            // Handle row selection/activation
            event.preventDefault();
            if (event.target.closest('.MuiDataGrid-row')) {
                const rowId = event.target.closest('.MuiDataGrid-row').getAttribute('data-id');
                // console.log('Row activated via keyboard:', rowId);
            }
        }
    };

    const normalizeMultiFilterModel = useCallback((incomingModel) => {
        const safeModel = incomingModel && typeof incomingModel === 'object'
            ? incomingModel
            : { items: [] };

        const normalizedItems = Array.isArray(safeModel.items)
            ? safeModel.items.map((item, index) => ({
                ...item,
                id: item?.id ?? `${item?.field || 'field'}-${item?.operator || 'op'}-${index}`
            }))
            : [];

        return {
            ...safeModel,
            items: normalizedItems
        };
    }, []);

    const handleGridFilterChange = (filterModel) => {
        setGridFilterModel(normalizeMultiFilterModel(filterModel));
    };

    const handleGridColumnOrderChange = useCallback(() => {
        const orderedFields = gridVisibleColumnFieldsSelector(queuedGridApiRef);
        columnOrderByTab.current[activeTab] = orderedFields;

        if (queuedGridApiRef.current?.exportState) {
            const state = queuedGridApiRef.current.exportState();
            savedGridStateByTab.current[activeTab] = { columns: state.columns };
        }
    }, [activeTab]);

    const handleColumnVisibilityModelChange = (model) => {
        setColumnVisibilityModel(model);
    };

    const handlePinnedColumnsChange = useCallback((model) => {
        const nextPinnedColumns = model || { left: [], right: [] };
        setPinnedColumns(nextPinnedColumns);

        savedGridStateByTab.current[activeTab] = {
            ...(savedGridStateByTab.current[activeTab] || {}),
            columns: {
                ...((savedGridStateByTab.current[activeTab] || {}).columns || {}),
                pinnedColumns: nextPinnedColumns
            }
        };
    }, [activeTab, setPinnedColumns]);

    const handleColumnWidthChange = useCallback((params) => {
        const field = params?.colDef?.field;
        const width = Number(params?.width);

        if (!field || !Number.isFinite(width) || width <= 0) {
            return;
        }

        setColumnWidths((previous) => {
            if (previous[field] === width) {
                return previous;
            }

            return {
                ...previous,
                [field]: width
            };
        });
    }, [setColumnWidths]);

    const getGridHeaderAnchor = () => {
        const root = queuedGridApiRef.current?.rootElementRef?.current;
        return root?.querySelector('.MuiDataGrid-columnHeaders') || null;
    };

    const getFirstColumnHeaderAnchor = () => {
        const root = queuedGridApiRef.current?.rootElementRef?.current;
        return root?.querySelector('.MuiDataGrid-columnHeader') || getGridHeaderAnchor();
    };

    const getResolvedPanelAnchor = () => {
        if (gridPanelAnchorEl && gridPanelAnchorEl.isConnected) {
            return gridPanelAnchorEl;
        }

        return getFirstColumnHeaderAnchor();
    };

    const handleColumnHeaderClick = () => {
        setGridPanelAnchorEl(getFirstColumnHeaderAnchor());
    };

    const getActiveToolbarIds = () => {
    const tabSuffixByIndex = {
        0: 'workflow',
        1: 'legal',
        2: 'walkin'
    };

    const suffix = tabSuffixByIndex[activeTab] || 'workflow';

    return {
        columnsButtonId: `queued-columns-button-${suffix}`,
        filtersButtonId: `queued-filters-button-${suffix}`
    };
};

    const handleOpenColumnsPanel = () => {
        if (!resultsQueued.length) {
            return;
        }

        const headerEl = getFirstColumnHeaderAnchor();
        setGridPanelAnchorEl(headerEl);
        // queuedGridApiRef.current.showPreferences(
        //     GridPreferencePanelsValue.columns,
        //     'queued-columns-panel',
        //     'queued-columns-button'
        // );
        const { columnsButtonId } = getActiveToolbarIds();

        queuedGridApiRef.current.showPreferences(
            GridPreferencePanelsValue.columns,
            'queued-columns-panel',
            columnsButtonId
        );
    };

    const handleOpenFiltersPanel = () => {
        if (!resultsQueued.length) {
            return;
        }

        const headerEl = getFirstColumnHeaderAnchor();
        setGridPanelAnchorEl(headerEl);

        // queuedGridApiRef.current.showPreferences(
        //     GridPreferencePanelsValue.filters,
        //     'queued-filters-panel',
        //     'queued-filters-button'
        // );

        const { filtersButtonId } = getActiveToolbarIds();

        queuedGridApiRef.current.showPreferences(
            GridPreferencePanelsValue.filters,
            'queued-filters-panel',
            filtersButtonId
        );
    };

    const handleOpenDensityMenu = (event) => {
        if (!resultsQueued.length) {
            return;
        }

        setDensityMenuAnchorEl(event.currentTarget);
    };

    const handleCloseDensityMenu = () => {
        setDensityMenuAnchorEl(null);
    };

    const handleDensityChange = (newDensity) => {
        setGridDensity(newDensity);
        if (queuedGridApiRef.current?.setDensity) {
            queuedGridApiRef.current.setDensity(newDensity);
        }
        handleCloseDensityMenu();
    };

    const handleGridClearFilters = () => {
        queueResetOnOptionsLoadRef.current = true;

        setCaseNumberIconsDisabled(defaultCaseNumberIconsDisabled);
        if (activeCaseSearchRef && activeCaseSearchRef.setValidationMessage) {
            activeCaseSearchRef.setValidationMessage("");
        }
        
        const allWorkflowValues = workflowOptions
        .filter((option) => option.value !== 'All')
        .map((option) => option.value);

        setWorkflowSelectedNone("");
        setQueueSelectedNone("");
        setWorkflowCleared(false);

        const startDate = cachedInitialDate || getTodayDate(); // Fallback to today if cached date is null
        const today = getTodayDate();

        dispatchFormData({
            ...initialFormData,
            startDateTxt: startDate,
            endDateTxt: today,
            hasValidDateData: true,
            workflowSelect: allWorkflowValues,
            queueSelect: []
        });

        // Reset any user-resized widths back to default column definitions.
        setColumnWidths({});

        if (savedGridStateByTab.current[activeTab]?.columns) {
            const existingColumns = savedGridStateByTab.current[activeTab].columns;
            const { dimensions, ...remainingColumnsState } = existingColumns;

            savedGridStateByTab.current[activeTab] = {
                ...savedGridStateByTab.current[activeTab],
                columns: remainingColumnsState
            };
        }
        
        setPaginationModel((previous) => ({ ...previous, page: 0 }));
        setColumnVisibilityModel({});
        setGridFilterModel({ items: [] });
        setGridDensity('standard');
    };

    const handleTabChange = (event, newValue) => {
        if (queuedGridApiRef.current?.exportState) {
            const state = queuedGridApiRef.current.exportState();
            savedGridStateByTab.current[activeTab] = {
                columns: state.columns  // only order and widths
            };
            // Also keep columnOrderByTab in sync so getCurrentColumnsW_O_EndWF renders
            // the correct order immediately when returning to this tab.
            if (state.columns?.orderedFields) {
                columnOrderByTab.current[activeTab] = state.columns.orderedFields;
            }
        }

        if (activeTab === 2 && newValue === 0) {
            shouldRefreshWorkflowAfterWalkInRef.current = true;
        }

        if (activeTab === 1 && newValue === 0) {
            shouldRefreshWorkflowAfterLegalRef.current = true;
        }

        setActiveTab(newValue);
        setGridPanelAnchorEl(null);
        setDensityMenuAnchorEl(null);
        setPaginationModel((previous) => ({ ...previous, page: 0 }));

        if (newValue === 0) {
            if (!clearStartdate) {
                dispatchFormData({ 
                    startDateTxt: getTodayDate(), 
                });
            }
        }

        if (newValue === 1) {
            setShowLegalHint(true);
            // Clear only Legal tab data so grid is empty until Refresh is clicked
            setResultsQueuedByTab((prev) => ({ ...prev, 1: [] }));
            setAllQueuedRowsByTab((prev) => ({ ...prev, 1: [] }));

            // Optional cleanup for a clean empty state
            setPaginationModelByTab((prev) => ({ ...prev, 1: { ...prev[1], page: 0 } }));
            setGridFilterModelByTab((prev) => ({ ...prev, 1: { items: [] } }));
            setSelectedRows([]);
        }

        if (newValue === 2) {
            handleSearchWalkInClick();
        }
    };

    const handleCloseNotificationDialog = () => {
        setNotificationDialogOpen(false);
        setNotificationDialogContent([]);
    };

    const handleDateFieldClear = async (fieldName) => {
        try {

            if (inputDateRefs.current[fieldName]) {
                inputDateRefs.current[fieldName].value = ""; // Explicitly clear the Date DOM value
            }

            const validDate = validateDateOnClear(fieldName);

            updateFormFieldValues({
                [fieldName]: "",
                hasValidDateData: validDate,
            });
            
            if (fieldName === "startDateTxt") {
                setClearStartdate(true);
                startDate = "";
                // Startdate = "";

                updateFormFieldValues({
                    startDateTxt: "mm/dd/yyyy"
                });
            }
        }
        catch (error) {
            await LoggerUtility.ManageErrorLogging(error, errorFormName, "handleDateFieldClear: " + fieldName);
        }
    };

    const handleBothDateFieldClear = async () => {
        try {
            // Clear the DOM input values directly
            if (inputDateRefs.current["startDateTxt"]) {
                inputDateRefs.current["startDateTxt"].value = "";
            }
            if (inputDateRefs.current["endDateTxt"]) {
                inputDateRefs.current["endDateTxt"].value = "";
            }

            // Validate cleared dates
            const validDate = setDateValidationMessage("", "");

            // Update form state with dispatchFormData directly
            dispatchFormData({
                type: 'UPDATE_FIELDS',
                payload: {
                    startDateTxt: "",
                    endDateTxt: "",
                    hasValidDateData: validDate,
                }
            });

            // Handle the special case for start date
            setClearStartdate(true);
            startDate = "";
            

            // Second dispatch for the placeholder text
            dispatchFormData({
                type: 'UPDATE_FIELDS',
                payload: {                    
                    startDateTxt: "mm/dd/yyyy"
                }
            });
        }
        catch (error) {
            await LoggerUtility.ManageErrorLogging(error, errorFormName, "handleBothDateFieldClear");
        }
    };

    const validateDateOnClear = (fieldName) => {
        let validDate = true;
        switch (fieldName) {
            case "startDateTxt":
                validDate = setDateValidationMessage("", searchFormData.endDateTxt);
                break;

            case "endDateTxt":
                validDate = setDateValidationMessage(searchFormData.startDateTxt, "");
                break;
        }

        return validDate;
    };


    const getAutoEndWorkflowsFromApi = async (autoEndWFParams) => {
        try {
            await ApiManager.GetAutoEndWorkflowsList(autoEndWFParams);
        }
        catch (error) {
        // setHasSearchResults(false);
        throw LoggerUtility.ProcessErrorData(error, "getAutoEndWorkflowsFromApi", {});
        }   
    };

    const handleAutoEndWorkflowQueueClick = async (event) => {
        event.preventDefault();
        setIsPageLoading(true);
        setResultsQueued([]);  // Clear previous results
        try {

            await getActiveWorkflowWorkApiData(buildQueuedSearchPayload(searchFormData)); // Refresh data to ensure we have the latest before processing auto-end

            const dataWithIds = queueSelectedData.map((item, index) => ({
                id: index + 1, // Required unique identifier for each row
            }));

            setResultsQueued(dataWithIds);

            let autoEndWFRows = getCheckedAutoEndWFRows();
            
            autoEndWFRows.forEach(row => {
                caseWorkflowIDList += String(row.caseWorkflowID) + ",";// Assuming caseWorkflowID is an array, adjust if it's a different structure
            });
            
            caseWorkflowIDList = caseWorkflowIDList.replace(/,$/, ''); 

            const autoEndWFParams = {
                CaseWorkflowList: caseWorkflowIDList,
                MasterServerDBSchema: masterServerDBSchema      
            };

            setPreviouslySelectedRows(selectedRows); // Use useState for previouslySelectedRows.
            const messageContent = await SharedService.getMessageContent(ClientType.MessageContent.N_UI7028_AutoEnd_Workflows);
            const confirmationMessage = (messageContent?.messageText || '').replace('{0}', autoEndWFRows.length);

            showConfirmation(`Auto-End Workflows`, confirmationMessage, 
                async () => {
                    // Your existing auto-end logic here
                    await getAutoEndWorkflowsFromApi(autoEndWFParams);
                    await handleSearchQueuedClick();
                    setSelectedRows([]);
                    handleDeleteAction();
                }
            );

        }
        catch (error) {
            await LoggerUtility.ManageErrorLogging(error, errorFormName, "handleAutoEndWorkflowQueueClick");
        }
        finally { setIsPageLoading(false); }
    }; 

    const getActiveWorkflowWorkApiData = async (buildQueuedSearchPayload) => {
        try {
            queueSelectedData = await ApiManager.GetActiveWorkflowWorkList(buildQueuedSearchPayload);
        }
        catch (error) {
        // setHasSearchResults(false);
        throw LoggerUtility.ProcessErrorData(error, "getActiveWorkflowWorkApiData", {});
        }   
    };

    // Get all rows where checkbox is checked
    const getCheckedAutoEndWFRows = () => {
        const checkedRows = resultsQueued.filter(row => selectedRows.includes(row.id));
        return checkedRows;
    };

    const getCurrentColumnsW_O_EndWF = () => {
        // Only apply saved column order if this tab has been previously searched
        const savedOrder = hasSearchedByTab.current[activeTab] ? columnOrderByTab.current[activeTab] : null;
        const orderedColumns = savedOrder
            ? (() => {
                const indexMap = new Map(savedOrder.map((field, i) => [field, i]));
                return [...currentColumnsWithCheckboxFilters].sort((a, b) => {
                    const ai = indexMap.has(a.field) ? indexMap.get(a.field) : Infinity;
                    const bi = indexMap.has(b.field) ? indexMap.get(b.field) : Infinity;
                    return ai - bi;
                });
            })()
            : currentColumnsWithCheckboxFilters;

        const columnsWithSavedWidths = orderedColumns.map((column) => {
            const savedWidth = columnWidths[column.field];

            if (!Number.isFinite(savedWidth) || savedWidth <= 0) {
                return column;
            }

            return {
                ...column,
                width: savedWidth
            };
        });
        
        // If role ID is not 1, filter out the autoEndWF column
        if (formFieldAccess.autoEndWorkflowBtn?.hide ?? false) {
            return columnsWithSavedWidths.filter(column => column.field !== 'autoEndWF');
        }
        
        return columnsWithSavedWidths;
    };

    // Add around line 1650, near handleCloseNotificationDialog:
    const showConfirmation = (title, message, onConfirm, showCancel = true) => {
        setConfirmationTitle(title);
        setConfirmationMessage(message);
        setConfirmationAction(() => onConfirm);
        setConfirmationOpen(true);
        setShowCancelButton(showCancel); // Add this new state
    };

    const handleConfirmationClose = async () => {
        setConfirmationOpen(false);
        setConfirmationTitle('');
        setConfirmationMessage('');
        setConfirmationAction(null);

        await handleSearchQueuedClick();
        setSelectedRows(previouslySelectedRows);
    };

    const handleConfirmationConfirm = async () => {
        if (confirmationAction) {  
            await confirmationAction();
        }
        setPreviouslySelectedRows([]); // Clear previously selected rows after confirmation
        setSelectedRows([]); // Clear selected rows after confirmation
    };

    const handleDeleteAction = async () => {
        showConfirmation(`Workflows Auto-Ended`,
                    `Complete`,
            () => {
                // This function runs when user clicks OK
                console.log("Deleting item...");
                // Your delete logic here
                setConfirmationOpen(false); 
            },
            false
        );
    };

    const isAllWorkflowsSelected = useMemo(() => {
    // Only show ALL checked when all selectable items are explicitly selected
    const selectableCount = workflowOptions.filter(opt => opt.value !== 'All').length;
    return selectableCount > 0 && 
           searchFormData.workflowSelect.length === selectableCount;
}, [workflowOptions, searchFormData.workflowSelect]);

    const workflowOptionsWithAll = useMemo(() => [
        { id: 'all', label: 'All', value: 'All' },
        ...workflowOptions
    ], [workflowOptions]);

    const workflowDisplayValue = useMemo(() => {
        if (isAllWorkflowsSelected) {
            return [{ id: 'all', label: 'All', value: 'All' }];
        }
        return workflowOptions.filter(option => 
            searchFormData.workflowSelect.includes(option.value)
        );
    }, [isAllWorkflowsSelected, workflowOptions, searchFormData.workflowSelect]);

    const toWorkflowValues = (newValue) => {
        if (!Array.isArray(newValue) || newValue.length === 0) return [];

        let selectedValues = newValue.map((option) => option.value);

        if (selectedValues.includes('All')) {
            selectedValues = workflowOptions
            .filter((option) => option.value !== 'All')
            .map((option) => option.value);
        }

        return selectedValues;
    };

    const isAllQueuesSelected = useMemo(() => {
    // Only show ALL checked when all selectable items are explicitly selected
    if (searchFormData.workflowSelect.length === 0) return false;
    const selectableCount = queueOptions.filter(opt => opt.value !== 'All').length;
    return selectableCount > 0 && 
           searchFormData.queueSelect.length === selectableCount;
}, [queueOptions, searchFormData.queueSelect, searchFormData.workflowSelect]);

    const [workflowCleared, setWorkflowCleared] = useState(false);

    const handleWorkflowClear = () => {
        // console.log('Before: workflowSelect =', searchFormData.workflowSelect);
        setWorkflowSelectedNone("NONE");
        setQueueSelectedNone("NONE");
        setWorkflowCleared(true);  // ← Flag it as cleared
        dispatchFormData({
        workflowSelect: [],
        queueSelect: []
        });
        // console.log('After (sync): workflowSelect =', searchFormData.workflowSelect); // Will show old value
    };

    // const handleQueueClear = () => {
    // setQueueSelectedNone("NONE");
    // };
    const handleQueueClear = () => {
        setQueueSelectedNone("NONE");
        dispatchFormData({ queueSelect: [] });
    };

    // const { searchFormData, resultsQueued, paginationModelByTab, columnVisibilityModel, gridFilterModel, gridDensity } = useContext(QueueContext);

    // SAVE SESSION STATE TO SESSION STORAGE ON UNMOUNT
    useEffect(() => {
        return () => {
            // Capture the current active tab's grid column state before unmounting
            if (queuedGridApiRef.current?.exportState) {
                const state = queuedGridApiRef.current.exportState();
                savedGridStateByTab.current[activeTab] = { columns: state.columns };
                if (state.columns?.orderedFields) {
                    columnOrderByTab.current[activeTab] = state.columns.orderedFields;
                }
            }
            try {
                sessionStorage.setItem('queuePageState', JSON.stringify({
                    searchFormDataByTab,
                    resultsQueuedByTab,
                    allQueuedRowsByTab,
                    paginationModelByTab,
                    columnVisibilityModelByTab,
                    columnWidthsByTab,
                    pinnedColumnsByTab,
                    gridFilterModelByTab,
                    gridDensityByTab,
                    includeSystemActionsByTab,
                    activeTab,
                    savedGridStateByTab: savedGridStateByTab.current,
                    columnOrderByTab: columnOrderByTab.current,
                    hasSearchedByTab: hasSearchedByTab.current
                }));
            } catch (e) {
                // sessionStorage quota exceeded; store only inputs/filters/column state
                try {
                    sessionStorage.setItem('queuePageState', JSON.stringify({
                        searchFormDataByTab,
                        paginationModelByTab,
                        columnVisibilityModelByTab,
                        columnWidthsByTab,
                        pinnedColumnsByTab,
                        gridFilterModelByTab,
                        gridDensityByTab,
                        includeSystemActionsByTab,
                        activeTab,
                        savedGridStateByTab: savedGridStateByTab.current,
                        columnOrderByTab: columnOrderByTab.current,
                        hasSearchedByTab: hasSearchedByTab.current
                    }));
                } catch (e2) {
                    // ignore if still fails
                }
            }
        };
    }, [searchFormDataByTab, resultsQueuedByTab, allQueuedRowsByTab, paginationModelByTab, columnVisibilityModelByTab, columnWidthsByTab, pinnedColumnsByTab, gridFilterModelByTab, gridDensityByTab, includeSystemActionsByTab, activeTab]);

    // RESTORE SESSION STATE FROM SESSION STORAGE ON MOUNT
    useEffect(() => {
        const saved = sessionStorage.getItem('queuePageState');
        if (saved) {
            try {
                const parsed = JSON.parse(saved);
                if (parsed.searchFormDataByTab) {
                    setSearchFormDataByTab(parsed.searchFormDataByTab);
                }
                if (parsed.resultsQueuedByTab) {
                    setResultsQueuedByTab(parsed.resultsQueuedByTab);
                }
                if (parsed.allQueuedRowsByTab) {
                    setAllQueuedRowsByTab(parsed.allQueuedRowsByTab);
                }
                if (parsed.paginationModelByTab) {
                    setPaginationModelByTab(parsed.paginationModelByTab);
                }
                if (parsed.columnVisibilityModelByTab) {
                    setColumnVisibilityModelByTab(parsed.columnVisibilityModelByTab);
                }
                if (parsed.columnWidthsByTab) {
                    setColumnWidthsByTab(parsed.columnWidthsByTab);
                }
                if (parsed.pinnedColumnsByTab) {
                    setPinnedColumnsByTab(parsed.pinnedColumnsByTab);
                }
                if (parsed.gridFilterModelByTab) {
                    setGridFilterModelByTab(parsed.gridFilterModelByTab);
                }
                if (parsed.gridDensityByTab) {
                    setGridDensityByTab(parsed.gridDensityByTab);
                }
                if (parsed.includeSystemActionsByTab) {
                    setIncludeSystemActionsByTab(parsed.includeSystemActionsByTab);
                }
                if (parsed.activeTab !== undefined) {
                    setActiveTab(parsed.activeTab);
                }
                // Rehydrate in-memory refs so the activeTab effect can restore column order
                if (parsed.savedGridStateByTab) {
                    savedGridStateByTab.current = parsed.savedGridStateByTab;
                }
                if (parsed.columnOrderByTab) {
                    columnOrderByTab.current = parsed.columnOrderByTab;
                }
                if (parsed.hasSearchedByTab) {
                    hasSearchedByTab.current = parsed.hasSearchedByTab;
                }
            } catch (e) {
                // corrupted session data; start fresh
                sessionStorage.removeItem('queuePageState');
            }
        }

        // Trigger a re-render so columns are recomputed with restored order.
        // Also ensures page-entry refresh logic can run even if no session exists.
        setRestoreCompleted(true);
    }, []);

    useEffect(() => {
            // Only restore state if this tab has been previously searched
            if (!hasSearchedByTab.current[activeTab]) {
                return;
            }

            const saved = savedGridStateByTab.current[activeTab];
            if (saved && queuedGridApiRef.current?.restoreState) {
                queuedGridApiRef.current.restoreState(saved);
            }
        }, [activeTab, restoreCompleted]);

    useEffect(() => {
        if (!restoreCompleted || activeTab !== 0) {
            return;
        }

        // Only auto-search if the Workflow tab has been previously searched
        if (!hasSearchedByTab.current[0]) {
            return;
        }

        if (shouldRefreshWorkflowAfterWalkInRef.current) {
            shouldRefreshWorkflowAfterWalkInRef.current = false;
            handleSearchQueuedClick();
            return;
        }

        if (shouldRefreshWorkflowAfterLegalRef.current) {
            shouldRefreshWorkflowAfterLegalRef.current = false;
            handleSearchQueuedClick();
            return;
        }

        if (hasAutoRefreshedOnEntryRef.current) {
            return;
        }

        hasAutoRefreshedOnEntryRef.current = true;
        handleSearchQueuedClick();
    }, [activeTab, restoreCompleted]);

    const renderWorkflowForm = (activeForm) => {

        return (
            <Box
                sx={{
                    display: activeForm ? 'block' : 'none'
                }}
            >
                <div style={{ width: "100%" }}>
                    {/* Filter Row - responsive layout for different screen sizes */}
                    <div style={{
                        display: "flex",
                        flexWrap: "wrap",
                        alignItems: "center",
                        gap: "12px",
                        padding: "16px 24px",
                        backgroundColor: "#ffffffff",
                        minHeight: "70px"
                    }} onKeyDown={handleFilterKeyDown}>
                        {/* Date Section - responsive container */}
                        <div style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "8px",
                            flexShrink: 0,
                            minWidth: "580px"
                        }}>
                            {/* Start Date Field */}
                            <div style={{ flex: "1 1 255px", maxWidth: "306px" }}>
                                <FormControl fullWidth>
                                <DatePicker
                                    selected={parseDateFromInput(searchFormData.startDateTxt)}
                                    onChange={handleStartDatePickerChange}
                                    maxDate={parseDateFromInput(searchFormData.endDateTxt) || undefined}
                                    filterDate={isStartDateSelectable}
                                    dateFormat="MM/dd/yyyy"
                                    placeholderText="MM/DD/YYYY"
                                    customInput={
                                        <TextField
                                            label="Start Date"
                                            size='small'
                                            id="startDateTxt"
                                            name="startDateTxt"
                                            InputLabelProps={{ shrink: true }}
                                            InputProps={{
                                                endAdornment: (
                                                    <InputAdornment position="end">
                                                        <IconButton
                                                            onClick={handleStartDateClear}
                                                            size="small"
                                                            sx={{ padding: '4px' }}
                                                        >
                                                            <ClearIcon fontSize="small" />
                                                        </IconButton>
                                                    </InputAdornment>
                                                )
                                            }}
                                            sx={{
                                                '& .MuiOutlinedInput-root': {
                                                    '&:hover fieldset': {
                                                        borderColor: '#5A73EA',
                                                    },
                                                    '&.Mui-focused fieldset': {
                                                        borderColor: '#5A73EA',
                                                    },
                                                },
                                                '& .MuiInputLabel-root.Mui-focused': {
                                                    color: '#5A73EA',
                                                }
                                            }}
                                        />
                                    }
                                />
                            </FormControl>
                        </div>
                       
                       
                        {/* End Date Field */}
                        <div style={{ flex: "1 1 255px", maxWidth: "306px" }}>
                            <FormControl fullWidth>
                                <DatePicker
                                    selected={parseDateFromInput(searchFormData.endDateTxt)}
                                    onChange={handleEndDatePickerChange}
                                    minDate={parseDateFromInput(searchFormData.startDateTxt) || undefined}
                                    filterDate={isEndDateSelectable}
                                    dateFormat="MM/dd/yyyy"
                                    placeholderText="MM/DD/YYYY"
                                    customInput={
                                        <TextField
                                            label="End Date"
                                            size='small'
                                            id="endDateTxt"
                                            name="endDateTxt"
                                            InputLabelProps={{ shrink: true }}
                                            InputProps={{
                                                endAdornment: (
                                                    <InputAdornment position="end">
                                                        <IconButton
                                                            onClick={handleEndDateClear}
                                                            size="small"
                                                            sx={{ padding: '4px' }}
                                                        >
                                                            <ClearIcon fontSize="small" />
                                                        </IconButton>
                                                    </InputAdornment>
                                                )
                                            }}
                                            sx={{
                                                '& .MuiOutlinedInput-root': {
                                                    '&:hover fieldset': {
                                                        borderColor: '#5A73EA',
                                                    },
                                                    '&.Mui-focused fieldset': {
                                                        borderColor: '#5A73EA',
                                                    },
                                                },
                                                '& .MuiInputLabel-root.Mui-focused': {
                                                    color: '#5A73EA',
                                                }
                                            }}
                                        />
                                    }
                                />
                            </FormControl>
                        </div>
                       
                        {/* Reset dates button */}
                        <Button
                            variant="contained"
                            onClick={async () => {
                                const startDate = cachedInitialDate || getTodayDate(); // Fallback to today if cached date is null
                                const today = getTodayDate();
                                setSelectedRows([]);
                                dispatchFormData({ startDateTxt: startDate, endDateTxt: today, hasValidDateData: true });
                            }}
                            sx={{
                                backgroundColor: '#5A73EA',
                                '&:hover': {
                                    backgroundColor: '#4A63DA'
                                },
                                padding: '8px 16px',
                                minWidth: '80px',
                                fontWeight: '500'
                            }}
                        >
                            RESET
                        </Button>
                        </div>
                       
                        {/* Case Search Field */}
                        <div style={{
                            flex: "1 1 225px",
                            // minWidth: "250px",
                            maxWidth: "350px",
                            marginLeft: "12px"
                        }}>
                            <TextFieldWithIconButton
                                ref={(node) => {
                                    caseSearchRefs.current[0] = node;
                                }}
                                nameForField="caseSearchTxt"
                                onIconButtonClick={handleCaseSearchClick}
                                onClearButtonClick={handleCaseSearchClear}
                                onTextChange={handleCaseSearchChange}
                                valueForField={searchFormData.caseSearchTxt}
                                labelForField="Case Search"
                                iconsTooltipText={{ search: 'Search Case', copy: 'Copy Case', clear: 'Clear Case' }}
                                iconsVisibility={{ search: false, copy: true, clear: true }}
                                iconsDisabled={caseNumberIconsDisabled}
                                sizeForControl="small"
                            />
                        </div>
                       
                        {/* Dropdowns Section - responsive container */}
                        <div style={{
                            display: "flex",
                            gap: "12px",
                            flex: "1 1 auto",
                            minWidth: "0",
                            flexWrap: "wrap"
                        }}>
                            {/* Four Dropdowns */}
                            <div style={{ flex: "1 1 200px", minWidth: "180px", maxWidth: "280px" }}>
                            <CustomAutoComplete
                                key={workflowSelectedNone}  // ← Add this
                                placeholder="ALL"  // Shows when no selection
                                customVariant='defaultVariant'
                                idForControl='workflowSelect'
                                labelForControl='Workflow'
                                multiple = {true}                        // ✓ Already set
                                disableCloseOnSelect={true}              // Add this - keeps dropdown open
                                // optionsSource={workflowOptionsWithAll}  // Use enhanced options
                                // valueForControl={workflowDisplayValue}
                                valueForControl={searchFormData.workflowSelect}
                                onChange={handleWorkflowSelectChange}
                                onClear={handleWorkflowClear} 
                                optionsSource={workflowOptions}
                                open={isWorkflowOpen}
                                onOpen={() => setIsWorkflowOpen(true)}
                                onClose={(event, closeReason) => {
                                    if (closeReason === "blur" && isClearingWorkflowRef.current) 
                                        return;
                                        //return <Chip label={`NONE (0)`} color="primary" style={{ backgroundColor: '#5A73EA' }} size="small" />;
                                    setIsWorkflowOpen(false);
                                }}
                                style={{ backgroundColor: '#fbe2e3' }}
                                labelKey='label'
                                valueKey='value'
                                renderOption={(props, option, { selected }) => {
                                    // For "All" option, show checked state based on isAllWorkflowsSelected
                                    const isChecked = option.value === 'All' ? isAllWorkflowsSelected : selected;
                                    return (
                                        <li {...props}>
                                        <Checkbox
                                            icon={<CheckBoxOutlineBlankIcon fontSize="small" />}
                                            checkedIcon={<CheckBoxIcon fontSize="small" />}
                                            style={{ marginRight: 8 } }
                                            checked={isChecked}
                                        />
                                        {option.label}
                                        </li>
                                    );
                                }}
                                noOptionsText='Workflow Not Found'
                                
                                renderTags={(tagValue, getTagProps) => {
                                    // console.log('renderTags called, workflowSelect =', searchFormData.workflowSelect, 'tagValue =', tagValue);
                                    if (workflowCleared || searchFormData.workflowSelect.length === 0) {
                                            return <Chip label={`NONE (0)`} color="primary" style={{ backgroundColor: '#5A73EA' }} size="small" />;
                                        }
                                    
                                    //const totalOptions = workflowOptions.length;
                                    const totalOptions = workflowOptions.filter(opt => opt.value !== 'All').length;
                                    const selectedCount = Array.isArray(tagValue) ? tagValue.length : 0; //tagValue.length;

                                    if (workflowSelectedNone === "NONE" || selectedCount === 0) {
                                        return <Chip label={`NONE (${0})`} color="primary" style={{ backgroundColor: '#5A73EA' }} size="small" />;
                                    }
                                    

                                    // Show "ALL" when nothing selected OR everything selected (excluding ALL option)
                                    if (selectedCount === 0 || selectedCount === totalOptions) {
                                    //if (selectedCount === totalOptions) {
                                        return <Chip label={`All (${totalOptions})`} color="primary" style={{ backgroundColor: '#5A73EA' }} size="small" />;
                                    }
                                    
                                    // Case 3: Single item selected - show item name
                                    if (selectedCount === 1) {
                                    return (
                                        <Chip
                                        {...getTagProps({ index: 0 })}
                                        label={tagValue[0].label}
                                        style={{ backgroundColor: '#5A73EA' }}
                                        color="secondary" 
                                        size="small"
                                        />
                                    );
                                    }
                                    
                                    // Case 4: Some items selected (but not all) - show "Multiple"
                                    return (
                                    <Chip
                                        label={`Multiple (${selectedCount})`}
                                        color="secondary" 
                                        style={{ backgroundColor: '#5A73EA' }}
                                        size="small"
                                    />
                                    );
                                }}
                            />
                        </div>
                        <div style={{ flex: "1 1 200px", minWidth: "180px", maxWidth: "280px" }}>
                            <CustomAutoComplete
                                customVariant='defaultVariant'
                                idForControl='queueSelect'
                                labelForControl='Queue'
                                multiple = {true}                         // ✓ Already set
                                // valueForControl={searchFormData.queueSelect}
                                valueForControl={queueSelectedNone === "NONE" || searchFormData.workflowSelect.length === 0 ? [] : searchFormData.queueSelect}
                                onChange={handleQueueSelectChange}
                                onClear={handleQueueClear}
                                optionsSource={queueOptions}
                                labelKey='label'
                                valueKey='value'
                                 renderOption={(props, option, { selected }) => {
                                    // For "All" option, show checked state based on isAllQueuesSelected
                                    const isChecked = option.value === 'All' ? isAllQueuesSelected : selected;
                                    return (
                                        <li {...props}>
                                        <Checkbox
                                            icon={<CheckBoxOutlineBlankIcon fontSize="small" />}
                                            checkedIcon={<CheckBoxIcon fontSize="small" />}
                                            style={{ marginRight: 8 }}
                                            checked={isChecked}
                                        />
                                        {option.label}
                                        </li>
                                    );
                                }}
                                noOptionsText='Queue Not Found'
                                renderTags={(tagValue, getTagProps) => {
                                    //const totalOptions = queueOptions.length;
                                    const totalOptions = queueOptions.filter(opt => opt.value !== 'All').length;
                                    const selectedCount = tagValue.length;

                                    if (queueSelectedNone === "NONE" || searchFormData.workflowSelect.length === 0) {
                                        // searchFormData.queueSelect = []; // Clear queue selection when queueSelectedNone is "NONE"
                                        return <Chip label={`NONE (${0})`} color="primary" style={{ backgroundColor: '#5A73EA' }} size="small" />;
                                    }

                                    // Show "ALL" when nothing selected OR everything selected (excluding ALL option)
                                    if (selectedCount === 0 || selectedCount === totalOptions) {
                                        return <Chip label={`All (${totalOptions})`} color="primary" style={{ backgroundColor: '#5A73EA' }} size="small" />;
                                    }
                                    
                                    // Case 3: Single item selected - show item name
                                    if (selectedCount === 1) {
                                    return (
                                        <Chip
                                        {...getTagProps({ index: 0 })}
                                        label={tagValue[0].label}
                                        style={{ backgroundColor: '#5A73EA' }}
                                        color="secondary" 
                                        size="small"
                                        />
                                    );
                                    }
                                    
                                    // Case 4: Some items selected (but not all) - show "Multiple"
                                    return (
                                    <Chip
                                        label={`Multiple (${selectedCount})`}
                                        color="secondary" 
                                        style={{ backgroundColor: '#5A73EA' }}
                                        size="small"
                                    />
                                    );
                                }}
                            />
                        </div>
                        </div>
                       
                        {/* Action buttons section - responsive */}
                        <div style={{
                            display: "flex",
                            gap: "12px",
                            flexShrink: 0,
                            marginLeft: "auto",
                            minWidth: "fit-content"
                        }}>
                            {!(formFieldAccess.searchBtn?.hide ?? false) && (
                                <Button
                                    id="searchBtn"
                                    name="searchBtn"
                                    variant="contained"
                                    sx={{
                                        backgroundColor: '#131E42',            
                                        padding: '8px 24px',
                                        minWidth: '100px',
                                        fontWeight: '500'
                                    }}
                                    onClick={handleSearchQueuedClick}
                                >
                                    SEARCH
                                </Button>
                            )}
                            { resultsQueued.length > 0 && (
                                <RoundedSquareRefreshButton onClick={handleSearchQueuedClick}>
                                <WhiteRefreshIcon></WhiteRefreshIcon>                                
                            </RoundedSquareRefreshButton>
                            )}
                            {!(formFieldAccess.clearFiltersBtn?.hide ?? false) && (
                                <Button
                                    id="clearFiltersBtn"
                                    name="clearFiltersBtn"
                                    variant="text"
                                    color="ywTextBlue"
                                    className="clear-filters-btn"
                                    onClick={handleGridClearFilters}
                                    disabled={!(formFieldAccess.clearFiltersBtn?.write ?? true)}
                                >
                                    CLEAR FILTERS
                                </Button>
                            )}
                        </div>
                    </div>
                    {/* Dotted line separator */}
                    <div className="dotted-line-div" style={{ padding: "4px 14px" }}>
                        <div style={{ padding: "2px" }}>
                        </div>
                    </div>
                    {/* Grid Control Buttons Row - responsive layout */}
                    <div style={{
                        display: "flex",
                        flexWrap: "wrap",
                        justifyContent: "space-between",
                        alignItems: "center",
                        padding: "8px 24px",
                        backgroundColor: "white",
                        gap: "12px"
                    }}>
                        <div style={{ display: "flex", gap: "16px", flexWrap: "wrap" }}>
                            <Button id="queued-columns-button-workflow" variant="text" sx={gridToolbarButtonSx} onClick={handleOpenColumnsPanel} disabled={resultsQueued.length === 0}>
                                <span style={{ marginRight: "6px", fontSize: "16px" }}>⋮⋮</span> COLUMNS
                            </Button>
                            <Button id="queued-filters-button-workflow" variant="text" sx={gridToolbarButtonSx} onClick={handleOpenFiltersPanel} disabled={resultsQueued.length === 0}>
                                <span style={{ marginRight: "6px", fontSize: "16px" }}>⧨</span> FILTERS
                            </Button>
                            <Button id="queued-density-button" variant="text" sx={gridToolbarButtonSx} onClick={handleOpenDensityMenu} disabled={resultsQueued.length === 0}>
                                <span style={{ marginRight: "6px", fontSize: "16px" }}>▦</span> DENSITY
                            </Button>
                            <Button
                                id="queued-export-button"
                                variant="text"
                                sx={gridToolbarButtonSx}
                                onClick={handleExportBtnClick}
                                disabled={resultsQueued.length === 0 || !(formFieldAccess.exportDocumentsBtn?.write ?? true)}
                            >
                                <span style={{ marginRight: "6px", fontSize: "16px" }}>⤴</span> EXPORT
                            </Button>
                            <Menu
                                anchorEl={densityMenuAnchorEl}
                                open={Boolean(densityMenuAnchorEl)}
                                onClose={handleCloseDensityMenu}
                            >
                                <MenuItem selected={gridDensity === 'compact'} onClick={() => handleDensityChange('compact')}>Compact</MenuItem>
                                <MenuItem selected={gridDensity === 'standard'} onClick={() => handleDensityChange('standard')}>Standard</MenuItem>
                                <MenuItem selected={gridDensity === 'comfortable'} onClick={() => handleDensityChange('comfortable')}>Comfortable</MenuItem>
                            </Menu>
                        </div>
                        <div style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "16px",
                            flexWrap: "wrap",
                            minWidth: "fit-content"
                        }}>
                            {!(formFieldAccess.autoEndWorkflowBtn?.hide ?? false) && (
                                <Button
                                    id="autoEndWorkflowBtn"
                                    name="autoEndWorkflowBtn"
                                    variant="contained"
                                    sx={{ backgroundColor: '#131E42', fontWeight: '500' }}
                                    onClick={handleAutoEndWorkflowQueueClick}
                                    disabled={selectedRows.length === 0 || !(formFieldAccess.autoEndWorkflowBtn?.write ?? true)}
                                >
                                    END WF
                                </Button>
                            )}
                        </div>
                    </div>
                    {!(formFieldAccess.queuedWorkflowActivityDgrd?.hide ?? false) && (
                    !hasSearched ? (
                    <div style={queuedEmptyStateStyle}>
                    <div style={{ fontSize: '18px', fontWeight: '525', color: '#5A73EA' }}>
                                  Don't worry. Use the filters!
                                </div>
                               <div style={{ fontSize: '16px', color: '#5A73EA', maxWidth: '450px' }}>
                                   Utilize the various filters above and search for the information you seek.
                           </div>
                    </div>
                    ) : resultsQueued.length === 0 ? (
                    <div style={queuedEmptyStateStyle}>
                        <div style={{ fontSize: '16px', color: '#5A73EA', maxWidth: '450px' }}>
                                   No results found.
                           </div>
                    </div>
                    ) : (   
                            <div style={queuedGridContainerStyle}>
                                <DataGridPremium
                                    apiRef={queuedGridApiRef}
                                    initialState={hasSearchedByTab.current[0] ? savedGridStateByTab.current[0] : undefined}
                                    id="queuedWorkflowActivityDgrd"
                                    name="queuedWorkflowActivityDgrd"
                                    rows={resultsQueued}
                                    //columns={currentColumns}
                                    columns={getCurrentColumnsW_O_EndWF()}
                                    density={gridDensity}
                                    pagination
                                    pageSizeOptions={[1000, 2000, 3000, 4000, 5000, resultsQueued.length]}
                                    rowsPerPageOptions={[1000, 2000, 3000, 4000, 5000]} 
                                    paginationModel={paginationModel}
                                    onPaginationModelChange={setPaginationModel}
                                    sortModel={sortModel}
                                    onSortModelChange={setSortModel}
                                    filterModel={gridFilterModel}
                                    disableMultipleColumnsFiltering={false}
                                    disableColumnReorder={false}
                                    pinnedColumns={pinnedColumns}
                                    onPinnedColumnsChange={handlePinnedColumnsChange}
                                    columnVisibilityModel={columnVisibilityModel}
                                    onColumnVisibilityModelChange={handleColumnVisibilityModelChange}
                                    onColumnWidthChange={handleColumnWidthChange}
                                    onRowDoubleClick={handleRowDoubleClick}
                                    onColumnHeaderClick={handleColumnHeaderClick}
                                    onFilterModelChange={handleGridFilterChange}
                                    onKeyDown={handleGridKeyDown}
                                    slots={{ footer: QueuedGridFooter }}
                                    sx={queuedGridSx}
                                    slotProps={{
                                        panel: {
                                        anchorEl: getResolvedPanelAnchor()
                                        }
                                    }}
                                    onColumnOrderChange={handleGridColumnOrderChange}
                                />
                                <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', padding: '24px 0' }}>
                                    </Box>
                            </div>
                    )
                    )}
                </div>
            </Box>
        );
    };

    const renderLegalForm = (activeForm) => {

        return (
            <Box
                sx={{
                    display: activeForm ? 'block' : 'none'
                }}
            >
                <div style={{ width: "100%" }}>
                    {/* Filter Row - responsive layout for different screen sizes */}
                    <div style={{
                        display: "flex",
                        flexWrap: "wrap",
                        alignItems: "center",
                        gap: "12px",
                        padding: "16px 24px",
                        backgroundColor: "#ffffffff",
                        minHeight: "70px"
                    }} onKeyDown={handleFilterKeyDown}>
                        {/* Date Section - responsive container */}                      
                        {/* Case Search Field */}
                        <div style={{
                            flex: "1 1 280px",
                            minWidth: "250px",
                            maxWidth: "350px",
                            marginLeft: "-10px"
                        }}>                           
                        </div>
                        
                       
                        {/* Action buttons section - responsive */}
                        <div style={{
                            display: "flex",
                            gap: "12px",
                            flexShrink: 0,
                            marginLeft: "auto",
                            minWidth: "fit-content"
                        }}>
                            {/* {!(formFieldAccess.searchBtn?.hide ?? false) && (
                                <Button
                                    id="searchBtn"
                                    name="searchBtn"
                                    variant="contained"
                                    sx={{
                                        backgroundColor: '#131E42',            
                                        padding: '8px 24px',
                                        minWidth: '100px',
                                        fontWeight: '500'
                                    }}
                                    onClick={handleSearchQueuedClick}
                                    // disabled={!(formFieldAccess.searchBtn?.write ?? true) || isCaseSearchInvalid}
                                    //disabled={!(formFieldAccess.searchBtn?.write ?? true)}
                                >
                                    SEARCH
                                </Button>
                            )} */}
                            <div>
                                <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', padding: '4px 0' }}>
                                    </Box>
                            {showLegalHint && (
                                <span style={{ color: '#ea5a5a', fontSize: '18px', fontStyle: 'italic', alignSelf: 'center' }}>
                                    Click Refresh to view all Legal Workflows.
                                </span>
                            )}
                        </div>
                            { (
                                <RoundedSquareRefreshButton sx={{
                                        backgroundColor: '#131E42',            
                                        // padding: '8px 24px',
                                        // minWidth: '100px',
                                        fontWeight: '500',
                                         '&:hover': {
                                            backgroundColor: '#131E42',
                                        }
                                    }}
                                onClick={handleSearchLegalClick}>
                                <WhiteRefreshIcon></WhiteRefreshIcon>                                
                            </RoundedSquareRefreshButton>
                            )}
                            {!(formFieldAccess.clearFiltersBtn?.hide ?? false) && (
                                <Button
                                    id="clearFiltersBtn"
                                    name="clearFiltersBtn"
                                    variant="text"
                                    color="ywTextBlue"
                                    className="clear-filters-btn"
                                    onClick={handleGridClearFilters}
                                    disabled={!(formFieldAccess.clearFiltersBtn?.write ?? true)}
                                >
                                    CLEAR FILTERS
                                </Button>
                            )}
                        </div>
                    </div>
                    {/* Dotted line separator */}
                    <div className="dotted-line-div" style={{ padding: "4px 14px" }}>
                        <div style={{ padding: "2px" }}>
                        </div>
                    </div>
                    {/* Grid Control Buttons Row - responsive layout */}
                    <div style={{
                        display: "flex",
                        flexWrap: "wrap",
                        justifyContent: "space-between",
                        alignItems: "center",
                        padding: "8px 24px",
                        backgroundColor: "white",
                        gap: "12px"
                    }}>
                        <div style={{ display: "flex", gap: "16px", flexWrap: "wrap" }}>
                            <Button id="queued-columns-button-legal" variant="text" sx={gridToolbarButtonSx} onClick={handleOpenColumnsPanel} disabled={resultsQueued.length === 0}>
                                <span style={{ marginRight: "6px", fontSize: "16px" }}>⋮⋮</span> COLUMNS
                            </Button>
                            <Button id="queued-filters-button-legal" variant="text" sx={gridToolbarButtonSx} onClick={handleOpenFiltersPanel} disabled={resultsQueued.length === 0}>
                                <span style={{ marginRight: "6px", fontSize: "16px" }}>⧨</span> FILTERS
                            </Button>
                            <Button id="queued-density-button" variant="text" sx={gridToolbarButtonSx} onClick={handleOpenDensityMenu} disabled={resultsQueued.length === 0}>
                                <span style={{ marginRight: "6px", fontSize: "16px" }}>▦</span> DENSITY
                            </Button>
                            <Button
                                id="queued-export-button"
                                variant="text"
                                sx={gridToolbarButtonSx}
                                onClick={handleExportBtnClick}
                                disabled={resultsQueued.length === 0 || !(formFieldAccess.exportDocumentsBtn?.write ?? true)}
                            >
                                <span style={{ marginRight: "6px", fontSize: "16px" }}>⤴</span> EXPORT
                            </Button>
                            <Menu
                                anchorEl={densityMenuAnchorEl}
                                open={Boolean(densityMenuAnchorEl)}
                                onClose={handleCloseDensityMenu}
                            >
                                <MenuItem selected={gridDensity === 'compact'} onClick={() => handleDensityChange('compact')}>Compact</MenuItem>
                                <MenuItem selected={gridDensity === 'standard'} onClick={() => handleDensityChange('standard')}>Standard</MenuItem>
                                <MenuItem selected={gridDensity === 'comfortable'} onClick={() => handleDensityChange('comfortable')}>Comfortable</MenuItem>
                            </Menu>
                        </div>
                        <div style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "16px",
                            flexWrap: "wrap",
                            minWidth: "fit-content"
                        }}>
                        </div>
                    </div>
                    {!(formFieldAccess.queuedWorkflowActivityDgrd?.hide ?? false) && (
                    !hasSearched ? (
                    <div style={queuedEmptyStateStyle}>
                    </div>
                    ) : resultsQueued.length === 0 ? (
                    <div style={queuedEmptyStateStyle}>
                        <div style={{ fontSize: '16px', color: '#5A73EA', maxWidth: '450px' }}>
                                   No task(s) found.
                           </div>
                    </div>
                    ) : (   
                            <div style={queuedGridContainerStyle}>
                                <DataGridPremium
                                    apiRef={queuedGridApiRef}
                                    initialState={hasSearchedByTab.current[1] ? savedGridStateByTab.current[1] : undefined}
                                    id="queuedWorkflowActivityDgrd"
                                    name="queuedWorkflowActivityDgrd"
                                    rows={resultsQueued}
                                    //columns={currentColumns}
                                    columns={getCurrentColumnsW_O_EndWF()}
                                    density={gridDensity}
                                    pagination
                                    pageSizeOptions={[1000, 2000, 3000, 4000, 5000, resultsQueued.length]}
                                    rowsPerPageOptions={[1000, 2000, 3000, 4000, 5000]} 
                                    paginationModel={paginationModel}
                                    onPaginationModelChange={setPaginationModel}
                                    sortModel={sortModel}
                                    onSortModelChange={setSortModel}
                                    filterModel={gridFilterModel}
                                    disableMultipleColumnsFiltering={false}
                                    disableColumnReorder={false}
                                    pinnedColumns={pinnedColumns}
                                    onPinnedColumnsChange={handlePinnedColumnsChange}
                                    columnVisibilityModel={columnVisibilityModel}
                                    onColumnVisibilityModelChange={handleColumnVisibilityModelChange}
                                    onColumnWidthChange={handleColumnWidthChange}
                                    onRowDoubleClick={handleRowLegalDoubleClick}
                                    onColumnHeaderClick={handleColumnHeaderClick}
                                    onFilterModelChange={handleGridFilterChange}
                                    onKeyDown={handleGridKeyDown}
                                    slots={{ footer: QueuedGridFooter }}
                                    sx={queuedGridSx}
                                    slotProps={{
                                        panel: {
                                            anchorEl: getResolvedPanelAnchor()
                                        }
                                    }}
                                    onColumnOrderChange={handleGridColumnOrderChange}
                                />
                                <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', padding: '24px 0' }}>
                                    </Box>
                            </div>
                    )
                    )}
                </div>
            </Box>
        );
    };

    const renderWalkInForm = (activeForm) => {

        return (
            <Box
                sx={{
                    display: activeForm ? 'block' : 'none'
                }}
            >
                <div style={{ width: "100%" }}>
                    {/* Filter Row - responsive layout for different screen sizes */}
                    <div style={{
                        display: "flex",
                        flexWrap: "wrap",
                        alignItems: "center",
                        gap: "12px",
                        padding: "16px 24px",
                        backgroundColor: "#ffffffff",
                        minHeight: "70px"
                    }} onKeyDown={handleFilterKeyDown}>
                        {/* Date Section - responsive container */}
                        <div style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "8px",
                            flexShrink: 0,
                            minWidth: "580px"
                        }}>
                            {/* Start Date Field */}
                            <div style={{ flex: "1 1 255px", maxWidth: "306px" }}>
                        </div>
                       
                       
                        {/* End Date Field */}
                        <div style={{ flex: "1 1 255px", maxWidth: "306px" }}>
                        </div>
                       
                        </div>
                       
                        {/* Dropdowns Section - responsive container */}
                        <div style={{
                            display: "flex",
                            gap: "12px",
                            flex: "1 1 auto",
                            minWidth: "0",
                            flexWrap: "wrap"
                        }}>
                        </div>
                       
                        {/* Action buttons section - responsive */}
                        <div style={{
                            display: "flex",
                            gap: "12px",
                            flexShrink: 0,
                            marginLeft: "auto",
                            minWidth: "fit-content"
                        }}>
                            <RoundedSquareRefreshButton sx={{
                                        backgroundColor: '#131E42',            
                                        // padding: '8px 24px',
                                        // minWidth: '100px',
                                        fontWeight: '500',
                                         '&:hover': {
                                            backgroundColor: '#131E42',
                                        }
                                    }}
                            onClick={handleSearchWalkInClick}>
                                <WhiteRefreshIcon></WhiteRefreshIcon>                                
                            </RoundedSquareRefreshButton>
                            {!(formFieldAccess.clearFiltersBtn?.hide ?? false) && (
                                <Button
                                    id="clearFiltersBtn"
                                    name="clearFiltersBtn"
                                    variant="text"
                                    color="ywTextBlue"
                                    className="clear-filters-btn"
                                    onClick={handleGridClearFilters}
                                    disabled={!(formFieldAccess.clearFiltersBtn?.write ?? true)}
                                >
                                    CLEAR FILTERS
                                </Button>
                            )}
                        </div>
                    </div>
                    {/* Dotted line separator */}
                    <div className="dotted-line-div" style={{ padding: "4px 14px" }}>
                        <div style={{ padding: "2px" }}>
                        </div>
                    </div>
                    {/* Grid Control Buttons Row - responsive layout */}
                    <div style={{
                        display: "flex",
                        flexWrap: "wrap",
                        justifyContent: "space-between",
                        alignItems: "center",
                        padding: "8px 24px",
                        backgroundColor: "white",
                        gap: "12px"
                    }}>
                        <div style={{ display: "flex", gap: "16px", flexWrap: "wrap" }}>
                            <Button id="queued-columns-button-walkin" variant="text" sx={gridToolbarButtonSx} onClick={handleOpenColumnsPanel} disabled={resultsQueued.length === 0}>
                                <span style={{ marginRight: "6px", fontSize: "16px" }}>⋮⋮</span> COLUMNS
                            </Button>
                            <Button id="queued-filters-button-walkin" variant="text" sx={gridToolbarButtonSx} onClick={handleOpenFiltersPanel} disabled={resultsQueued.length === 0}>
                                <span style={{ marginRight: "6px", fontSize: "16px" }}>⧨</span> FILTERS
                            </Button>
                            <Button id="queued-density-button" variant="text" sx={gridToolbarButtonSx} onClick={handleOpenDensityMenu} disabled={resultsQueued.length === 0}>
                                <span style={{ marginRight: "6px", fontSize: "16px" }}>▦</span> DENSITY
                            </Button>
                            <Button
                                id="queued-export-button"
                                variant="text"
                                sx={gridToolbarButtonSx}
                                onClick={handleExportBtnClick}
                                disabled={resultsQueued.length === 0 || !(formFieldAccess.exportDocumentsBtn?.write ?? true)}
                            >
                                <span style={{ marginRight: "6px", fontSize: "16px" }}>⤴</span> EXPORT
                            </Button>
                            <Menu
                                anchorEl={densityMenuAnchorEl}
                                open={Boolean(densityMenuAnchorEl)}
                                onClose={handleCloseDensityMenu}
                            >
                                <MenuItem selected={gridDensity === 'compact'} onClick={() => handleDensityChange('compact')}>Compact</MenuItem>
                                <MenuItem selected={gridDensity === 'standard'} onClick={() => handleDensityChange('standard')}>Standard</MenuItem>
                                <MenuItem selected={gridDensity === 'comfortable'} onClick={() => handleDensityChange('comfortable')}>Comfortable</MenuItem>
                            </Menu>
                        </div>
                        <div style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "16px",
                            flexWrap: "wrap",
                            minWidth: "fit-content"
                        }}>

                             { //resultsQueued.length > 0 && (
                                <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                    <span>Refresh Interval (Seconds): </span>
                                    <TextField
                                        type="number"
                                        size="small"
                                        style={{ width: '70px' }}
                                        value={refreshInterval}
                                        onChange={(e) => setRefreshInterval(Number(e.target.value))}
                                        onClick={(e) => e.stopPropagation()}
                                        inputProps={{ min: 0 }}
                                    />
                                </div>
                            //)
                            }
                        </div>
                    </div>
                    {!(formFieldAccess.queuedWorkflowActivityDgrd?.hide ?? false) && (
                    !hasSearched ? (
                    <div style={queuedEmptyStateStyle}>
                    </div>
                    ) : resultsQueued.length === 0 ? (
                    <div style={queuedEmptyStateStyle}>
                        <div style={{ fontSize: '16px', color: '#5A73EA', maxWidth: '450px' }}>
                                   No task(s) found.
                           </div>
                    </div>
                    ) : (   
                            <div style={queuedGridContainerStyle}>
                                <DataGridPremium
                                    apiRef={queuedGridApiRef}
                                    initialState={hasSearchedByTab.current[2] ? savedGridStateByTab.current[2] : undefined}
                                    id="queuedWorkflowActivityDgrd"
                                    name="queuedWorkflowActivityDgrd"
                                    rows={resultsQueued}
                                    //columns={currentColumns}
                                    columns={getCurrentColumnsW_O_EndWF()}
                                    density={gridDensity}
                                    pagination
                                    pageSizeOptions={[1000, 2000, 3000, 4000, 5000, resultsQueued.length]}
                                    rowsPerPageOptions={[1000, 2000, 3000, 4000, 5000]} 
                                    paginationModel={paginationModel}
                                    onPaginationModelChange={setPaginationModel}
                                    sortModel={sortModel}
                                    onSortModelChange={setSortModel}
                                    filterModel={gridFilterModel}
                                    disableMultipleColumnsFiltering={false}
                                    disableColumnReorder={false}
                                    pinnedColumns={pinnedColumns}
                                    onPinnedColumnsChange={handlePinnedColumnsChange}
                                    columnVisibilityModel={columnVisibilityModel}
                                    onColumnVisibilityModelChange={handleColumnVisibilityModelChange}
                                    onColumnWidthChange={handleColumnWidthChange}
                                    onRowDoubleClick={handleRowWalkInDoubleClick}
                                    onColumnHeaderClick={handleColumnHeaderClick}
                                    onFilterModelChange={handleGridFilterChange}
                                    onKeyDown={handleGridKeyDown}
                                    slots={{ footer: QueuedGridFooter }}
                                    sx={queuedGridSx}
                                    slotProps={{
                                        panel: {
                                            anchorEl: getResolvedPanelAnchor()
                                        }
                                    }}
                                    onColumnOrderChange={handleGridColumnOrderChange}
                                />
                                <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', padding: '24px 0' }}>
                                    </Box>
                            </div>
                    )
                    )}
                </div>
            </Box>
        );
    };

    
    const mainQueuedContent = (
       <div style={{ height: '100%', width: '100%', paddingTop: '40px', position: 'absolute' }}>
        
         {/* <div style={queuePageRootStyle}> */}
            <div className="flex-main-frame" >
            {/* <div className="flex-main-frame" style={queuePageMainStyle}>     */}
                <div className="content-main-container" style={{ width: '100%' }}>
                    <div className="pane-wrap-container">
                        <div className="pane-main-full-width-container">
                            <div className="form-section">
                                <Stack
                                    direction="row"
                                    alignItems="center"
                                    sx={{
                                        width: '100%'
                                    }}
                                >
                                    <div class="text-wrapper-queued-title" style={{ padding: '10px 20px', fontSize: '20px', fontWeight: 300, fontFamily: "Noir Pro-Light, Helvetica", color: 'black' }}>Queue </div>
                                    <Tabs
                                        value={activeTab}
                                        onChange={handleTabChange}
                                        aria-label="queued tabs"
                                        sx={{
                                            "& .MuiTab-root": {
                                                fontFamily: "Roboto, Helvetica, Arial, sans-serif",
                                                fontWeight: 500,
                                                color: "rgba(0, 0, 0, 0.6)",
                                                "&.Mui-selected": {
                                                    color: "#5A73EA"
                                                },
                                                "&.Mui-disabled": {
                                                    color: "rgba(0, 0, 0, 0.3)"
                                                }
                                            },
                                            "& .MuiTabs-indicator": {
                                                backgroundColor: "#5A73EA"
                                            }
                                        }}
                                    >
                                        {!(formFieldAccess.btnQueueWorkflow?.hide ?? false) && (
                                        <Tab label="WORKFLOW" />
                                        )}
                                        {!(formFieldAccess.btnQueueLegal?.hide ?? false) && (
                                        <Tab label="LEGAL" />
                                        )}
                                        {!(formFieldAccess.btnQueueWalkIn?.hide ?? false) && (
                                        <Tab label="Walk-In" />
                                        )}
                                    </Tabs>
                                </Stack>                                
                                <div className='row' style={{ width: '100%', padding: "0px 14px" }}>
                                    <div className='col-12' style={{ borderBottom: '1px solid grey' }}>
                                    </div>
                                </div>
                                <Box display="flex"
                                    flexDirection="column"
                                    sx={{ display: "flex",  }}
                                >
                                    {/* // All forms rendered at once, visibility controlled by active prop
                                    <div style={{ width: '100%', visibility: activeTab === 0 ? 'visible' : 'hidden' }}>
                                        {renderWorkflowForm(activeTab === 0)}
                                    </div>
                                    <div style={{ width: '100%', visibility: activeTab === 1 ? 'visible' : 'hidden' }}>
                                        {renderLegalForm(activeTab === 1)}
                                    </div>
                                    <div style={{ width: '100%', visibility: activeTab === 2 ? 'visible' : 'hidden' }}>
                                        {renderWalkInForm(activeTab === 2)}
                                    </div> */}
                                     {activeTab === 0 && renderWorkflowForm(true)}
                                     {activeTab === 1 && renderLegalForm(true)}
                                     {activeTab === 2 && renderWalkInForm(true)}
                                </Box>
                            </div>
                        </div>
                    </div >
                </div>
            </div>
        </div>
    );


    return (
        <div>
            {mainQueuedContent}

            {/* Include the Notification Dialog component */}
            <NotificationDialog
                openNotification={notificationDialogOpen}
                dialogContent={notificationDialogContent}
                onCloseNotification={handleCloseNotificationDialog}
                isAutoClose={timerAutoCloseNotificationDialog}
                timerDuration={timerNotificationDialogClose}
            />
            // Add after the NotificationDialog (around line 2850), before AlertNotification:
            <Dialog
                open={confirmationOpen}
                onClose={handleConfirmationClose}
                aria-labelledby="confirmation-dialog-title"
            >
                <DialogTitle id="confirmation-dialog-title">
                    {confirmationTitle}
                </DialogTitle>
                <DialogContent>
                    <DialogContentText>
                        {confirmationMessage}
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                     {showCancelButton && (
                        <Button onClick={handleConfirmationClose} color="inherit">
                            Cancel
                        </Button>
                    )}
                    <Button onClick={handleConfirmationConfirm} color="primary" variant="contained">
                        OK
                    </Button>
                </DialogActions>
            </Dialog>

            <AlertNotification
                alertType={alertProps.type}
                message={alertProps.message}
                open={alertProps.open}
                onClose={handleAlertClose}
            />

            <Dialog open={exportDialogOpen} onClose={handleExportDialogClose} maxWidth="md" fullWidth >
                <Box sx={{borderRadius: '8px'}}>
                            {/* <DialogTitle sx={{ fontWeight: 600, color: '#131E42',fontSize: '24px' }}>Export</DialogTitle> */}
                            <DialogTitle sx={{ m: 0, p: 2 }}>
                                <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                                <Typography variant="h6" sx={{ fontWeight: 600, fontSize: "24px" }}>
                                    Export
                                </Typography>

                                <IconButton
                                    aria-label="close"
                                    onClick={handleExportDialogClose}
                                    size="small"
                                    sx={{ color: 'text.secondary' }}
                                >
                                    <CloseIcon />
                                </IconButton>
                                </Box>
                            </DialogTitle>
                            <DialogContent sx={{ py: 3 }}>
                               
                                <fieldset>
                                    <legend>
                                        <span style={{ fontWeight: 500, fontSize: "18px" }}>
                                        Headers
                                        </span>
                                    </legend>
                                    <input sx={{ backgroundColor: '#5A73EA','&:hover': { backgroundColor: '#5A73EA' } }}
                                    type="radio"
                                    name="includeHeaders"
                                    value="yes"
                                    checked={includeHeaders}
                                    onChange={() => setIncludeHeaders(true)}
                                    />
                                    <span style={{ marginLeft: "6px", marginRight: "24px", fontSize: "18px" }}>
                                            Include Headers
                                        </span>

                                    <input sx={{ backgroundColor: '#5A73EA','&:hover': { backgroundColor: '#5A73EA' } }}
                                    type="radio"
                                    name="includeHeaders"
                                    value="no"
                                    checked={!includeHeaders}
                                    onChange={() => setIncludeHeaders(false)}
                                    />
                                    <span style={{ marginLeft: "6px", marginRight: "24px", fontSize: "18px" }}>
                                            No Headers
                                        </span>



                                </fieldset>

                                <fieldset>
                                    <legend>
                                        <span style={{ fontWeight: 500, fontSize: "18px" }}>
                                        Format
                                        </span>
                                    </legend>
                                    <label>
                                        <input sx={{ backgroundColor: '#5A73EA','&:hover': { backgroundColor: '#5A73EA' } }} type="radio" name="format" value="excel"  onChange={handleFormatChange} checked={format === 'excel'} />
                                        <span style={{ marginLeft: "6px", marginRight: "116px", fontSize: "18px" }}>
                                            Excel
                                        </span>
                                    </label>
                                    <label>
                                        <input sx={{ backgroundColor: '#5A73EA','&:hover': { backgroundColor: '#5A73EA' } }} type="radio" name="format" value="csv"  onChange={handleFormatChange} checked={format === 'csv'} />
                                        <span style={{ marginLeft: "6px", marginRight: "24px", fontSize: "18px" }}>
                                            CSV
                                        </span>
                                    </label>
                                    {/* <label>
                                        <input sx={{ backgroundColor: '#5A73EA','&:hover': { backgroundColor: '#5A73EA' } }} type="radio" name="format" value="pdf"  onChange={handleFormatChange} checked={format === 'pdf'} />
                                        <span style={{ marginLeft: "6px", marginRight: "24px", fontSize: "18px" }}>
                                            PDF
                                        </span>
                                    </label> */}
                                </fieldset>

                                <fieldset>
                                    <legend>
                                        <span style={{ fontWeight: 500, fontSize: "18px" }}>
                                        Page Selection
                                        </span>
                                    </legend>
                                    <label>
                                        <input sx={{ backgroundColor: '#5A73EA','&:hover': { backgroundColor: '#5A73EA' } }} type="radio" name="pageSelection" value="current"  onChange={handlePageSelectionChange} checked={pageSelection === 'current'} />
                                        <span style={{ marginLeft: "6px", marginRight: "98px", fontSize: "18px" }}>
                                            Current
                                        </span>
                                    </label>
                                    <label>
                                        <input sx={{ backgroundColor: '#5A73EA','&:hover': { backgroundColor: '#5A73EA' } }} type="radio" name="pageSelection" value="all"  onChange={handlePageSelectionChange} checked={pageSelection === 'all'} />
                                        <span style={{ marginLeft: "6px", marginRight: "36px", fontSize: "18px" }}>
                                            All
                                        </span>
                                    </label>
                                </fieldset>
                                <fieldset>
                                    <legend>
                                        <span style={{ fontWeight: 500, fontSize: "18px" }}>
                                            Filters
                                        </span>
                                    </legend>

                                    <input sx={{ backgroundColor: '#5A73EA','&:hover': { backgroundColor: '#5A73EA' } }}
                                    type="radio"
                                    name="includeFilters"
                                    value="yes"
                                    checked={includeFilters}
                                    onChange={() => setIncludeFilters(true)}
                                    />
                                    <span style={{ marginLeft: "6px", marginRight: "66px", fontSize: "18px" }}>
                                                                                With Filters
                                                                            </span>

                                    <input sx={{ backgroundColor: '#5A73EA','&:hover': { backgroundColor: '#5A73EA' } }}
                                    type="radio"
                                    name="includeFilters"
                                    value="no"
                                    checked={!includeFilters}
                                    onChange={() => setIncludeFilters(false)}
                                    />
                                    <span style={{ marginLeft: "6px", marginRight: "24px", fontSize: "18px" }}>
                                                                                Without Filters
                                        </span>



                                </fieldset>
                                <fieldset>
                                    <legend>
                                        <span style={{ fontWeight: 500, fontSize: "18px" }}>
                                        File Name
                                        </span>
                                    </legend>
                                </fieldset>
                                <Box sx={{
                                            display: 'flex',
                                            alignItems: 'center',
                                            gap: 2,
                                            mt: -2,
                                            flexWrap: 'wrap' // keeps it usable on smaller screens
                                        }}
                                >
    
                                <input
                                        type="text"
                                        name="fileName"
                                        onChange={handleFileNameChange}
                                        value={fileName}
                                        style={{ width: "550px", fontSize: "18px", height: "36px" }}
                                    />
                                <Button
                                        onClick={handleExportExecute}
                                        variant="contained"
                                        disabled={!fileName.trim()} 
                                        sx={{
                                            backgroundColor: '#131E42',
                                            fontWeight: 500,
                                            ml: 8,
                                            mt: '40px',
                                            '&:hover': { backgroundColor: '#131E42'}
                                        }}
                                        >
                                        DOWNLOAD
                                    </Button>
                                <Button
                                    onClick={handleExportDialogClose}
                                    // variant="text"
                                    variant="contained"
                                    sx={{ backgroundColor: '#5A73EA', fontWeight: 500, mt: '40px', '&:hover': { backgroundColor: '#5A73EA' } }}
                                >
                                    Cancel
                                </Button>
                                </Box>
                                
                            </DialogContent>
                            </Box>
                        </Dialog>

            {/* Include the loader component */}
            <PageLoader isPageLoading={isPageLoading} />

        </div>
    );
});

export default QueueWorkflow;

